/**
 * API Service for handle http request
 */
export class ApiService {
	basePath = '';
	middleware = '';
	constructor(basePath, middleware = {}) {
		this.basePath = basePath;
		this.middleware = middleware;
	}

	// Generic request for all the endpoints
	async httpRequest(method, path, body, options = {}) {
		let response;

		try {
			let token = localStorage.getItem('Authorization');
			response = await fetch(`${this.basePath}${path}`, {
				method,
				headers: {
					...(options.multiPart ? {} : body ? {['Content-Type']: 'application/json'} : {}),
					// ...(options.location ? {} : { Authorization: `Bearer ${token}` })
					...{Authorization: `Bearer ${token}`},
				},
				body: options.multiPart ? body : body ? JSON.stringify(body) : undefined,
			});
		} catch (e) {
			if (e instanceof Error) {
				this.middleware.onError?.(e);
				return;
			}
		}
		// handle if error from API
		if (response && response.ok) {
			try {
				return await response.json();
			} catch (e) {
				if (e instanceof Error) {
					this.middleware.onError?.(e);
				}

				throw e;
			}
		} else {
			// handle all other errors
			await this.handleResponseError(response);
		}
	}

	async httpRequestBlob(method, path, body, options = {}) {
		let response;

		try {
			let token = localStorage.getItem('Authorization');
			response = await fetch(`${this.basePath}${path}`, {
				method,
				headers: {
					...(options.multiPart ? {} : body ? {['Content-Type']: 'application/json'} : {}),
					// ...(options.location ? {} : { Authorization: `Bearer ${token}` })
					...{Authorization: `Bearer ${token}`},
				},
				body: options.multiPart ? body : body ? JSON.stringify(body) : undefined,
			});
		} catch (e) {
			console.log(e);
			if (e instanceof Error) {
				this.middleware.onError?.(e);
				return;
			}
		}
		// handle if error from API
		if (response && response.ok) {
			try {
				const blob = await response.blob();

				// Extract filename from headers
				const disposition = response.headers.get('Content-Disposition');
				let filename = 'download.csv';
				if (disposition && disposition.includes('filename=')) {
					filename = disposition.split('filename=')[1].split(';')[0].replace(/"/g, '');
					filename = filename.split('~~')[0].replace(/"/g, '');
				}

				// Download the blob
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				link.remove();
				window.URL.revokeObjectURL(url);

				return; // no need to return blob
			} catch (e) {
				if (e instanceof Error) {
					this.middleware.onError?.(e);
				}
				throw e;
			}
		} else {
			await this.handleResponseError(response);
		}
	}

	// Handle API response errors
	async handleResponseError(response) {
		let json;
		try {
			json = await response.json();
		} catch (e) {
			json = e;
		}
		this.middleware.onError?.(json);
		throw json;
	}

	//  API To Make Get Request for Common API
	getRequest(apiUrl) {
		return this.httpRequest('GET', `${apiUrl}`, null);
	}
	//  API To Make Get Request for Common API
	getRequestWithParams(apiUrl) {
		return this.httpRequest('GET', `${apiUrl}`, null);
	}
	//  API call to Make Get Request for fetching categories by brand
	getCategoryByBrand(brandId) {
		return this.httpRequest('GET', `/brands/get-all-categories/${brandId}`, null);
	}

	/**
	 * Login Request API Call
	 * @param {*} data
	 * @returns
	 */
	adminLogin(data) {
		return this.httpRequest('POST', `/generic/users/login-user`, data);
		// return true;
	}
	/**
	 * export products API Call
	 * @param {*} data
	 * @returns
	 */
	exportProducts(data) {
		return this.httpRequestBlob('POST', `/generic/export/products`, data);
		// return true;
	}
	getCategoryDropDownForExport(data) {
		return this.httpRequest('POST', `/generic/export/category-dropdown`, data);
		// return true;
	}
	getBrandDropDownForExport(data) {
		return this.httpRequest('POST', `/generic/export/brand-dropdown`, data);
		// return true;
	}
	/**
	 * export category API Call
	 * @param {*} data
	 * @returns
	 */
	exportCategory(data) {
		return this.httpRequestBlob('POST', `/generic/export/category`, data);
		// return true;
	}

	exportPincodeMap(data) {
		return this.httpRequestBlob('POST', `/generic/export/pincode_store_map`, data);
		// return true;
	}
	/**
	 * export brands API Call
	 * @param {*} data
	 * @returns
	 */
	exportBrands(data) {
		return this.httpRequestBlob('POST', `/generic/export/brand`, data);
		// return true;
	}

	/**
	 * Create Tag API Call
	 * @param {*} data
	 * @returns
	 */
	createTag(data, multiPart = true) {
		return this.httpRequest('POST', `/tags`, data, {multiPart});
	}

	/**
	 * Update Tag API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateTag(data, id) {
		return this.httpRequest('PUT', `/tags/${id}`, data, {multiPart: true});
	}

	/**
	 * Delete Tag API Call
	 * @param {*} data
	 * @returns
	 */
	deleteTag(data) {
		return this.httpRequest('DELETE', `/tags`, data);
	}

	/**
	 * Create Variant API Call
	 * @param {*} data
	 * @returns
	 */
	createVariant(data) {
		return this.httpRequest('POST', `/attributeValues`, data);
	}

	/**
	 * Update Variant API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateVariant(data, id) {
		return this.httpRequest('PUT', `/attributeValues/${id}`, data);
	}

	/**
	 * Delete Variant API Call
	 * @param {*} data
	 * @returns
	 */
	deleteVariant(data) {
		return this.httpRequest('DELETE', `/attributeValues`, data);
	}

	/**
	 * Create product basic details
	 */

	createBasicDetails(data) {
		return this.httpRequest('POST', '/products/basic-details', data);
	}

	/**
	 * Update product basic details
	 */

	updatedBasicDetails(data, id) {
		return this.httpRequest('PUT', `/products/basic-details/${id}`, data);
	}

	/**
	 * Update media details
	 */

	updatedMediaDetails(data, id, multiPart = false) {
		return this.httpRequest('POST', `/products/media-details/${id}`, data, {multiPart});
	}

	/**
	 * Update seo details
	 */

	updatedSeoDetails(data, id) {
		return this.httpRequest('POST', `/products/seo-details/${id}`, data);
	}

	/**
	 * Update Attributes details
	 */

	updatedAttributesDetails(data, id) {
		return this.httpRequest('POST', `/products/attributes/${id}`, data);
	}

	/**
	 * Update Variant details
	 */

	updatedVariantDetails(data, id, multiPart = true) {
		return this.httpRequest('POST', `/products/variants/${id}`, data, {multiPart});
	}
	/**
	 * Delete Variant details
	 */

	deleteVariantDetails(id) {
		return this.httpRequest('DELETE', `/products/variants/${id}`, null);
	}

	/**
	 * function to fetch wallet brand data
	 * @returns
	 */
	getWalletBrandDetails() {
		return this.httpRequest(
			'GET',
			`/wallets/brands/all/0/100?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}

	/**
	 * function to fetch wallet category data
	 * @returns
	 */
	getWalletCategoryDetails() {
		return this.httpRequest(
			'GET',
			`/wallets/categories/all/0/1000?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}

	/**
	 * function to fetch wallet product data
	 * @returns
	 */
	getWalletProductDetails(val = null) {
		if (val) {
			return this.httpRequest('GET', `/wallets/products/all/0/1000?sortOrder=desc&searchTerm=${val}`, null);
		} else {
			return this.httpRequest('GET', `/wallets/products/all/0/1000?sortOrder=desc`, null);
		}
	}

	/**
	 * Update Coupon API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateCoupon(data, id) {
		return this.httpRequest('PUT', `/coupons/${id}`, data);
	}

	/**
	 * Delete Coupon API Call
	 * @param {*} data
	 * @returns
	 */
	deleteCoupon(data) {
		return this.httpRequest('DELETE', `/coupons`, data);
	}

	/**
	 * function to fetch coupon brand data
	 * @returns
	 */
	getCouponBrandDetails() {
		return this.httpRequest(
			'GET',
			`/coupons/brands/all/0/100?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}
	/**
	 * function to fetch coupon category data
	 * @returns
	 */
	getCouponCategoryDetails() {
		return this.httpRequest(
			'GET',
			`/coupons/categories/all/0/100?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}
	/**
	 * function to fetch coupon product data
	 * @returns
	 */
	getCouponProductDetails(val) {
		if (val) {
			return this.httpRequest('GET', `/coupons/products/all/0/200?sortOrder=desc&searchTerm=${val}`, null);
		} else {
			return this.httpRequest('GET', `/coupons/products/all/0/200?sortOrder=desc`);
		}
	}

	/**
	 * function to fetch offers brand data
	 * @returns
	 */
	getOffersBrandDetails() {
		return this.httpRequest(
			'GET',
			`/offers/brands/all/0/100?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}
	/**
	 * function to fetch offers category data
	 * @returns
	 */
	getOffersCategoryDetails() {
		return this.httpRequest(
			'GET',
			`/offers/categories/all/0/100?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}
	/**
	 * function to fetch offers product data
	 * @returns
	 */
	getOffersProductDetails() {
		return this.httpRequest(
			'GET',
			`/offers/products/all/0/100?filterTerm={"status" : "active"}&sortOrder=desc`,
			null
		);
	}

	/**
	 * function to fetch wallet product data
	 * @returns
	 */
	getMappedProductDetails(id) {
		return this.httpRequest('GET', `/walletmaps/${id}`, null);
	}

	/**
	 * get Variant details
	 */

	getVariantDetails(id) {
		return this.httpRequest('GET', `/products/variants/${id}`, null);
	}

	/**
	 * Update Price Detail
	 */

	updatedPriceDetails(data, id) {
		return this.httpRequest('POST', `/products/price-details/${id}`, data);
	}
	/**
	 * Get Seo details
	 */

	getSeoDetails(id) {
		return this.httpRequest('GET', `/products/seo-details/${id}`, null);
	}

	/**
	 * Get Price details
	 */

	getPriceDetails(id) {
		return this.httpRequest('GET', `/products/price-details/${id}`, null);
	}
	/**
	 * Get all state details
	 */

	getAllState() {
		return this.httpRequest('GET', `/products/countryStates/0/100`, null);
	}

	/**
	 * Get all department for employee
	 */

	getAllDepartment() {
		return this.httpRequest('GET', `/employee/all-departments`, null);
	}

	/**
	 * Get all company for employee
	 */

	getAllCompany() {
		return this.httpRequest('GET', `/employee/all-company`, null);
	}

	/**
	 * Get Attributes details
	 */

	getAttributesDetails(id) {
		return this.httpRequest('GET', `/products/attributes/${id}`, null);
	}

	/**
	 * Get product  basic details
	 */

	getBasicDetails(id) {
		return this.httpRequest('GET', `/products/basic-details/${id}`, null);
	}

	/**
	 * Get Media details
	 */

	getMediaDetails(id) {
		return this.httpRequest('GET', `/products/media-details/${id}`, null);
	}
	/**
	 * Create Attributes API Call
	 * @param {*} data
	 * @returns
	 */
	createAttributes(data) {
		return this.httpRequest('POST', `/attributes`, data);
	}

	/**
	 * Get Single Wallet details
	 * @param {*} id
	 * @returns
	 */
	getSingleWalletDetails(id) {
		return this.httpRequest('GET', `/wallets/${id}`, null);
	}

	/**
	 * Get Credit List of AB
	 * @param {*} dist_no
	 * @returns
	 */
	getAllCreditsByAB(dist_no) {
		return this.httpRequest('GET', `/walletMaps/ab-credits/${dist_no}`, null);
	}
	/**
	 * Create All Wallet API Call
	 * @param {*} data
	 * @returns
	 */
	addEditWallet(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/wallets/${id}`, data);
		} else {
			return this.httpRequest('POST', `/wallets`, data);
		}
	}

	/**
	 * Create coupon API Call
	 * @param {*} data
	 * @returns
	 */
	createCoupon(data) {
		return this.httpRequest('POST', `/coupons`, data);
	}

	/**
	 * Get Single Wallet details
	 * @param {*} id
	 * @returns
	 */
	getSingleCouponDetails(id) {
		return this.httpRequest('GET', `/coupons/${id}`, null);
	}

	/**
	 * function to create mapped data
	 * @param {*} data
	 * @returns
	 */
	createMappedData(data) {
		return this.httpRequest('POST', `/walletMaps`, data);
	}

	createTdsMappedData(data) {
		return this.httpRequest('POST', `/walletMaps/add-tds`, data);
	}

	/**
	 * function to update mapped data
	 * @param {*} data
	 * @returns
	 */
	updateMappedData(data, id) {
		return this.httpRequest('PUT', `/walletMaps/${id}`, data);
	}

	/**
	 * function to update wallet detail
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateAllWallet(data, id) {
		return this.httpRequest('PUT', `/wallets/${id}`, data);
	}

	/**
	 * function to fetch all wallet detail
	 */
	getAllWalletDetails() {
		return this.httpRequest('GET', `/generic/wallet/all/0/100`, null);
	}

	/**
	 * function to fetch all user
	 */
	getAllUserDetails() {
		return this.httpRequest('GET', `/walletmaps/users/all/0/100?sortOrder=desc`, null);
	}
	/**
	 * Create Attributes API Call
	 * @param {*} data
	 * @returns
	 */
	updateAttributes(data, id) {
		return this.httpRequest('PUT', `/attributes/${id}`, data);
	}

	/**
	 * Delete Attributes API Call
	 * @param {*} data
	 * @returns
	 */
	deleteAttributes(data) {
		return this.httpRequest('DELETE', `/attributes`, data);
	}

	/**
	 * Create Brand API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */
	createBrand(data, multiPart = false) {
		return this.httpRequest('POST', `/brands`, data, {multiPart});
	}

	/**
	 * Create Brands API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */
	updateBrand(data, id, multiPart = false) {
		return this.httpRequest('PUT', `/brands/${id}`, data, {multiPart});
	}

	/**
	 * Delete Brands API Call
	 * @param {*} data
	 * @returns
	 */
	deleteBrand(data) {
		return this.httpRequest('DELETE', `/brands`, data);
	}

	/**
	 * Delete Mapped Wallet API Call
	 * @param {*} data
	 * @returns
	 */
	deleteMappedWallet(data) {
		return this.httpRequest('DELETE', `/walletmaps`, data);
	}

	/**
	 * Delete product API Call
	 * @param {*} data
	 * @returns
	 */
	deleteProduct(data) {
		return this.httpRequest('DELETE', `/products`, data);
	}

	/**
	 * Create Category API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */
	createCategory(data, multiPart = false) {
		return this.httpRequest('POST', `/categories`, data, {multiPart});
	}

	/**
	 * Create Category API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */
	updateCategory(data, id, multiPart = false) {
		return this.httpRequest('PUT', `/categories/${id}`, data, {multiPart});
	}

	/**
	 * Delete Category API Call
	 * @param {*} data
	 * @returns
	 */
	deleteCategory(data) {
		return this.httpRequest('DELETE', `/categories`, data);
	}

	// Get All Modules
	getAllModules() {
		return this.httpRequest('GET', `/modules/get-all-modules`, null);
	}

	// Get All Generic Modules for role section
	getGenericModules() {
		return this.httpRequest('GET', `/generic/get-all-modules`, null);
	}

	// Get All Permissions
	getAllModulesPermissions() {
		return this.httpRequest('GET', `/permissions/get-all-permissions`, null);
	}

	// Create Role
	createRole(data) {
		return this.httpRequest('POST', `/roles/add-role`, data);
	}

	// Get Single Role Data
	getSingleRoleData(id) {
		return this.httpRequest('GET', `/mappings/get-single-role-mapping/${id}`, null);
	}

	// Update Role
	updateRole(id, data) {
		return this.httpRequest('PATCH', `/roles/update-role/${id}`, data);
	}

	// Delete role
	deleteSingleRole(data) {
		return this.httpRequest('POST', `/roles/delete-multiple-role`, data);
	}

	// Delete user
	deleteSingleUser(data) {
		return this.httpRequest('POST', `/users/delete-multiple-user`, data);
	}

	// Get All Roles
	getAllRoles() {
		return this.httpRequest('GET', `/roles/get-all-roles/0/200`);
	}

	// Create New User
	createUser(data) {
		return this.httpRequest('POST', `/users/add-user`, data);
	}

	// GET Single User Details
	getSingleUserDetails(id) {
		return this.httpRequest('GET', `/users/get-single-user/${id}`);
	}

	// Update Role
	updateUser(id, data) {
		return this.httpRequest('PUT', `/users/update-user/${id}`, data);
	}

	// Role Permission
	getRolePermission(id) {
		return this.httpRequest('GET', `/mappings/get-single-role-mapping/${id}`);
	}

	// Delete wallet
	deleteWallet(data) {
		return this.httpRequest('DELETE', `/wallets`, data);
	}

	/**
	 * Upload mapped bulk file API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */

	uploadMappedBulkUploadFile(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/walletmaps/bulk-upload/${randomId}`, data, {multiPart});
	}

	/**
	 * Upload mapped bulk file API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */

	uploadPincodeBulkUploadFile(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/pincodemaps/bulk-edit/${randomId}`, data, {multiPart});
	}

	/**
	 * Upload bulk file API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */

	uploadBulkUploadFile(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/products/bulk-upload/${randomId}`, data, {multiPart});
	}

	// Add Offer Module - Data Based on Applicable On API
	getDataBasedonApplicableOn(type) {
		return this.httpRequest('GET', `/offers/${type}/all/0/100?filterTerm={"status":"active"}&sortOrder=desc`, null);
	}

	// Add Offer Module - Products List API
	getProductsListForOffer() {
		return this.httpRequest(
			'GET',
			`/offers/products/all/0/100?filterTerm={"status":"active"}&sortOrder=desc`,
			null
		);
	}

	// Add Offer Module -Products Api
	getProductsForCoupon(val = null, offerId, isEligible = false) {
		if (val) {
			return this.httpRequest(
				'GET',
				`/offers/products/all/0/10/?searchTerm=${val}&sortOrder=desc&isOffer=true&isEligible=${isEligible}&offerId=${offerId}`,
				null
			);
		} else {
			return this.httpRequest(
				'GET',
				`/offers/products/all/0/10?sortOrder=desc&isOffer=true&isEligible=${isEligible}`,
				null
			);
		}
	}

	// Add Offer Module - Add Offer API
	addOffer(data) {
		return this.httpRequest('POST', `/offers`, data);
	}

	// Add Offer Module - role data
	getAllUsersGroup() {
		return this.httpRequest('GET', `/offers/get-all-roles/0/500`, null);
	}

	// Add Offer Module -Data Based on Applicable On API
	getSingleOfferDetails(id) {
		return this.httpRequest('GET', `/offers/${id}`, null);
	}

	// Offer Module -Delete Offer
	deleteSingleOffer(data) {
		return this.httpRequest('DELETE', `/offers`, data);
	}
	// Offer module - update Offer
	updateOffer(data, id) {
		return this.httpRequest('PUT', `/offers/${id}`, data);
	}
	// Offer module - get offers by financial year
	getOffersByFY(data) {
		return this.httpRequest('POST', `/offer-report/get-by-financial-year`, data);
	}
	// Offer module - get offers by financial year
	getOffersByFYAndOfferId(data) {
		return this.httpRequest('POST', `/offer-report/get-by-fy-and-offer-id`, data);
	}

	//Forgot Password request
	sendOTP(data) {
		return this.httpRequest('POST', `/generic/users/forget-password`, data);
	}

	// validate OTP
	validateOTP(data) {
		return this.httpRequest('POST', `/generic/users/validate-otp`, data);
	}
	// confidm password
	confirmPassword(data, id) {
		return this.httpRequest('POST', `/generic/users/change-password/${id}`, data);
	}

	changePassword(data) {
		return this.httpRequest('POST', `/generic/change-password`, data);
	}

	// resend OTP
	resendOTP(data) {
		return this.httpRequest('POST', `/generic/users/forget-password`, data);
	}

	// CSO Module - Add CSO API
	addCSO(data) {
		return this.httpRequest('POST', `/csos`, data);
	}

	// CSO Module - Delete CSO API
	deleteCSO(data) {
		return this.httpRequest('DELETE', `/csos`, data);
	}

	// CSO Module - Single CSO API
	getSingleCSODetail(id) {
		return this.httpRequest('GET', `/csos/${id}`);
	}

	// CSO Module - UpdateSingle CSO API
	updateSingleCSODetail(id, data) {
		return this.httpRequest('PUT', `/csos/${id}`, data);
	}

	/**
	 * get store code
	 */
	getStoreCode(code) {
		return this.httpRequest('GET', `/pincodeMaps/check-code/${code}`, null);
	}

	// Pincode store map Module - Get Pincode List API
	getStorePincodeList(val) {
		return this.httpRequest('GET', `/pincodeMaps/pincode/all/?searchTerm=${val}`);
	}

	/**
	 * Create pincode mapping API Call
	 * @param {*} data
	 * @returns
	 */
	createPincodeMapping(data) {
		return this.httpRequest('POST', `/pincodemaps`, data);
	}

	/**
	 * Update pincode mapping API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updatePincodeMapping(data, id) {
		return this.httpRequest('PUT', `/pincodemaps/${id}`, data);
	}

	/**
	 * Delete pincode mapping API Call
	 * @param {*} data
	 * @returns
	 */
	deletePincodeMapping(data) {
		return this.httpRequest('DELETE', `/pincodemaps`, data);
	}

	// CSO Map Module - Get CSO List API
	getCSOList(searchVal) {
		if (searchVal) {
			return this.httpRequest('GET', `/csomaps/cso/all/0/10?searchTerm=${searchVal}`);
		} else {
			return this.httpRequest('GET', `/csomaps/cso/all/0/10`);
		}
	}

	// CSO Map Module - Get State List API
	getStateListForCSOMap() {
		return this.httpRequest('GET', `/csomaps/states/all/0/50`);
	}

	// CSO Map Module - Get Distric List API
	getDistrictList(val) {
		return this.httpRequest('GET', `/csomaps/district/all/?filterTerm={"state_name":${JSON.stringify(val)}}`);
	}

	// CSO Map Module - Get Pincode List API
	getPincodeList(val) {
		if (typeof val == 'object') {
			return this.httpRequest('GET', `/csomaps/pincode/all/?searchTerm=${val?.search}&filterTerm=${val?.state}`);
		} else {
			return this.httpRequest('GET', `/csomaps/pincode/all/?filterTerm=${val}`);
		}
	}

	// CSO Map Module - Get Pincode List API
	addCSOMapping(val) {
		return this.httpRequest('POST', `/csomaps/`, val);
	}

	// CSO Map Module - Get Single Cson Map Details API
	getSingleCSOMapDetails(id) {
		return this.httpRequest('GET', `/csomaps/${id}`);
	}

	// CSO Map Module - Update Single CSO Map API
	updateCSOMapping(id, data) {
		return this.httpRequest('PUT', `/csomaps/${id}`, data);
	}

	// CSO Module - Delete CSO API
	deleteCSOMap(data) {
		return this.httpRequest('DELETE', `/csomaps`, data);
	}

	// CSO Module - Single CSO API
	getCSODepots() {
		return this.httpRequest('GET', `/depots/all/0/500`);
	}

	// Shipping Price Module - Add API
	addShippingCharges(val) {
		return this.httpRequest('POST', `/shippingcharges/`, val);
	}

	// Shipping Price Module - Add API
	getAllShippingCharges(val) {
		return this.httpRequest('GET', `/shippingcharges/`);
	}

	getSingleShippingChargesDetails(id) {
		return this.httpRequest('GET', `/shippingcharges/${id}`);
	}

	updateSingleShippingChargesDetails(id, body) {
		return this.httpRequest('PUT', `/shippingcharges/${id}`, body);
	}

	deleteShippingCharges(data) {
		return this.httpRequest('DELETE', `/shippingcharges/`, data);
	}

	/**
	 * Create download API Call
	 * @param {*} data
	 * @returns
	 */
	// createDownload(data, multiPart = true) {
	//   return this.httpRequest("POST", `/downloads/add-download-doc`, data, { multiPart });
	// }

	createDownload(id, data, multiPart = true) {
		return id
			? this.httpRequest('PUT', `/downloads/update-download-doc/${id}`, data, {multiPart})
			: this.httpRequest('POST', `/downloads/add-download-doc`, data, {multiPart});
	}

	getSingleDownloadContent(id) {
		return this.httpRequest('GET', `/downloads/${id}`);
	}
	/**
	 * Edit download API Call
	 * @param {*} data
	 * @returns
	 */
	editDownload(data, id, multiPart = true) {
		return this.httpRequest('PUT', `/downloads/update-download-doc/${id}`, data, {multiPart});
	}
	/**
	 * Delete download API Call
	 * @param {*} data
	 * @returns
	 */
	deleteDownload(data) {
		return this.httpRequest('DELETE', `/downloads/delete-multiple-docs/`, data);
	}

	shippingCharges(id, body) {
		return id
			? this.httpRequest('PUT', `/shippingcharges/${id}`, body)
			: this.httpRequest('POST', `/shippingcharges/`, body);
	}

	uploadBrandsBulkUploadFile(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/brands/bulk-upload/${randomId}`, data, {multiPart});
	}

	uploadCategoryBulkUploadFile(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/categories/bulk-upload/${randomId}`, data, {multiPart});
	}

	//Banner mangemnt- create new  Api
	addUpdateBannerdetails(id, data, multiPart = true) {
		return id
			? this.httpRequest('PUT', `/banner_list/${id}`, data, {multiPart})
			: this.httpRequest('POST', `/banner_list`, data, {multiPart});
	}

	getSingleBannerdetails(id) {
		return this.httpRequest('GET', `/banner_list/${id}`);
	}
	deleteBanners(data) {
		return this.httpRequest('DELETE', `/banner_list/`, data);
	}

	// Settings Module - create new setting
	createSetting(data) {
		return this.httpRequest('POST', `/settings`, data);
	}
	// Settings Module - getsetting
	getAllSettings() {
		return this.httpRequest('GET', `/settings`);
	}

	updateAllSettings(data) {
		return this.httpRequest('PUT', `/settings`, data);
	}

	getAllKycModules() {
		return this.httpRequest('GET', `/settings/get-kyc-modules`);
	}

	// Fetch all MDM modules from the modules
	getAllMdmModules() {
		return this.httpRequest('GET', `/mdm-settings/get-all-modules`);
	}

	// Fetch all MDM (ecom) modules for the ecom schedule maintenance setting
	getAllEcomMdmModules() {
		return this.httpRequest('GET', `/mdm-settings/get-all-ecom-modules`);
	}

	// Create a new MDM setting record
	createMdmSetting(data) {
		return this.httpRequest('POST', `/mdm-settings/create`, data);
	}

	// Update multiple MDM settings in a single request
	updateAllMdmSettings(data) {
		return this.httpRequest('PUT', `/mdm-settings/update`, data);
	}

	// Clear MDM Cache by Key
	clearMdmCache(data) {
		return this.httpRequest('POST', `/mdm-settings/clear-cache`, data);
	}

	// Get MDM Cache List
	getMdmCacheList() {
		return this.httpRequest('GET', `/mdm-settings/cache-list`);
	}

	/**
	 * Create Notification Category API Call
	 * @param {*} data
	 * @returns
	 */
	createNotificationCategory(data) {
		return this.httpRequest('POST', `/notification_category_list`, data);
	}
	/**
	 * Update Notification Category API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateNotificationCategory(data, id) {
		return this.httpRequest('PUT', `/notification_category_list/${id}`, data);
	}
	/**
	 * Delete Notification Category API Call
	 * @param {*} data
	 * @returns
	 */
	deleteNotificationCategory(data) {
		return this.httpRequest('DELETE', `/notification_category_list`, data);
	}

	/**
	 * Create Notification API Call
	 * @param {*} data
	 * @returns
	 */
	createNotification(data, multiPart = true) {
		return this.httpRequest('POST', `/notification_list`, data, {multiPart});
	}
	/**
	 * Update Notification API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateNotification(data, id, multiPart = true) {
		return this.httpRequest('PUT', `/notification_list/${id}`, data, {multiPart});
	}
	/**
	 * Delete Notification API Call
	 * @param {*} data
	 * @returns
	 */
	deleteNotification(data) {
		return this.httpRequest('DELETE', `/notification_list`, data);
	}

	// Pincode store map Module - Get Pincode List API
	getCategoryNotification(val) {
		return this.httpRequest('GET', `/notification_list/notification-categories-all/0/200?searchTerm=${val}`);
	}

	/**
	 * Send Notification API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	sendNotification(id) {
		return this.httpRequest('PUT', `/notification_list/send-notifications/${id}`);
	}

	/**
	 * Create Send Notification API Call
	 * @param {*} data
	 * @returns
	 */
	createSendNotification(data, multiPart = true) {
		return this.httpRequest('POST', `/send_notification_list`, data, {multiPart});
	}
	/**
	 * Update Send Notification API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateSendNotification(data, id, multiPart = true) {
		return this.httpRequest('PUT', `/send_notification_list/${id}`, data, {multiPart});
	}

	// Products Section : get products
	getAllProductsforProductsSection(data) {
		if (data) {
			return this.httpRequest('GET', `/product_section/products/all/0/200?searchTerm=${data}`);
		} else {
			return this.httpRequest('GET', `/product_section/products/all/0/200`);
		}
	}

	// Products Section : add product section
	addEditProductSection(data, id, multiPart = true) {
		if (id) {
			return this.httpRequest('PUT', `/product_section/${id}`, data, {multiPart});
		} else {
			return this.httpRequest('POST', `/product_section/`, data, {multiPart});
		}
	}

	// Products Section : add product section
	getSingleProductSection(id) {
		return this.httpRequest('GET', `/product_section/${id}`);
	}
	// Products Section : delete product section
	deleteProductSection(data) {
		return this.httpRequest('DELETE', `/product_section`, data);
	}

	// Products Section : view single product section's product
	getProductsForView(id) {
		return this.httpRequest('GET', `/product_section/view-product/${id}`);
	}

	// menu mangement : add menu
	addUpdateMenu(data) {
		if (data?.id) {
			return this.httpRequest('PUT', `/menu_management/${data?.id}`, data?.payload);
		} else {
			return this.httpRequest('POST', `/menu_management`, data?.payload);
		}
	}
	// menu mangement : get single menu data
	getSingleMenuData(id) {
		return this.httpRequest('GET', `/menu_management/${id}`);
	}
	// menu mangement : delete menu
	deleteMenus(data) {
		return this.httpRequest('DELETE', `/menu_management`, data);
	}

	// menu mangement : get categories list
	getCategoriesForMenuData() {
		return this.httpRequest('GET', `/generic/all-categories`);
	}

	// menu mangement : get brands list
	getBrandsForMenuData() {
		return this.httpRequest('GET', `/generic/all-brands`);
	}
	// menu mangement : get parent menu list
	getParentMenuListData() {
		return this.httpRequest('GET', `/generic/all-parent-menu`);
	}

	// featured Category : get categories list
	getAllCategoriesForFeatured() {
		return this.httpRequest('GET', `/featured_categories/categories/all`);
	}

	// featured Category : update categories sequence
	updateCategoriesForFeatured(data) {
		return this.httpRequest('PUT', `/featured_categories/`, data);
	}

	// featured Category : get featured categories list
	getFeaturedCategoriesList() {
		return this.httpRequest('GET', `/featured_categories/all`);
	}

	// featured Category : get single featured category data
	getSingleFeaturedCategoryData(id) {
		return this.httpRequest('GET', `/featured_categories/${id}`);
	}

	// featured Category : update single featured category data
	updatetSingleFeaturedCategoryData(id, data, multiPart = true) {
		return this.httpRequest('PUT', `/featured_categories/${id}`, data, {multiPart});
	}

	// manage media - category : get parent category list
	getParentMediaCategoryListData() {
		return this.httpRequest('GET', `/media_categories/all`);
	}

	// manage media - category : delete category
	deleteMediaCategory(data) {
		return this.httpRequest('DELETE', `/media_categories`, data);
	}

	// manage media - category : add/edit category
	addUpdateMediaCategory(data) {
		if (data?.id) {
			return this.httpRequest('PUT', `/media_categories/${data?.id}`, data?.payload);
		} else {
			return this.httpRequest('POST', `/media_categories`, data?.payload);
		}
	}

	// menu mangement - category : get single media category data
	getSingleMediaCategoryData(id) {
		return this.httpRequest('GET', `/media_categories/single/${id}`);
	}

	// menu mangement - media content :  add/edit media content
	addEditSingleMediaContent(id, data, multiPart = true) {
		if (id) {
			return this.httpRequest('PUT', `/media_content/${id}`, data, {multiPart});
		} else {
			return this.httpRequest('POST', `/media_content`, data, {multiPart});
		}
	}

	// menu mangement - media content : get media categories iist
	getCategoriesListForMediaContent() {
		return this.httpRequest('GET', `/media_content/get-all-parent-category`);
	}
	// menu mangement - media content : get media sub categories iist
	getSubCategoriesListForMediaContent(id) {
		return this.httpRequest('GET', `/media_content/get-all-child-category/${id}`);
	}

	// menu mangement - media content : get single media content data
	getSingleMediaContentData(id) {
		return this.httpRequest('GET', `/media_content/${id}`);
	}

	// manage media - media content : delete media content
	deleteMediaContent(data) {
		return this.httpRequest('DELETE', `/media_content`, data);
	}

	// ab message : add/edit ab message
	addUpdateABMessage(id, data, multiPart = true) {
		if (id) {
			return this.httpRequest('PUT', `/ab_message/${id}`, data, {multiPart});
		} else {
			return this.httpRequest('POST', `/ab_message`, data, {multiPart});
		}
	}

	// ab message : get single  ab message data
	getSingleABmessageData(id) {
		return this.httpRequest('GET', `/ab_message/${id}`);
	}

	// ab message : delete ab message
	deleteSingleABmessage(data) {
		return this.httpRequest('DELETE', `/ab_message`, data);
	}

	AparajitaUploadBrandsBulkUploadFile(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/report/bulk-upload/${randomId}`, data, {multiPart});
	}

	//---------------------- Crm Api-----------------------------------------------------------------------------------------------------------
	getCrmOrders(data) {
		return this.httpRequest('POST', `/crm_order/get-order-detail`, data);
	}
	markCrmOrdersDelivered(data) {
		return this.httpRequest('POST', `/crm_order/bulk-mark-delivered`, data, {multiPart: true});
	}
	markCrmOrdersUndelivered(data) {
		return this.httpRequest('POST', `/crm_order/bulk-mark-undelivered`, data, {multiPart: true});
	}
	getCrmBulkUndeliveredQueue(params = {}) {
		const query = new URLSearchParams();
		Object.entries(params).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== '') query.set(key, value);
		});
		return this.httpRequest('GET', `/crm_order/bulk-undelivered-queue?${query.toString()}`, null);
	}
	retryCrmBulkUndelivered(payload) {
		return this.httpRequest('POST', `/crm_order/bulk-undelivered-retry`, payload);
	}
	getCrmReturnOrders(data) {
		return this.httpRequest('POST', `/crm_order/get-return-order-detail`, data);
	}

	// crm order by date
	getCrmOrdersByDate(data) {
		delete data?.search_type;
		return this.httpRequest('POST', `/crm_order/get-order-by-date`, data);
	}

	getCrmOrdersByDateDownload(data, arg) {
		delete data?.search_type;
		return this.httpRequestBlob('POST', `/crm_order/get-order-by-date-download`, data);
	}
	getCrmOrdersByDateDownloadReturn(data, arg) {
		delete data?.search_type;
		return this.httpRequestBlob('POST', `/crm_order/get-order-by-date-download-return`, data);
	}

	// Failed orders
	getFailedOrders(data) {
		delete data?.search_type;
		return this.httpRequest('POST', `/crm_order/get-failed-orders`, data);
	}

	getFailedOrdersDownload(data) {
		delete data?.search_type;
		return this.httpRequestBlob('POST', `/crm_order/get-failed-orders-download`, data);
	}

	// crm order by date
	getCrmReturnOrdersByDate(data) {
		delete data?.search_type;

		if (data?.is_export) {
			return this.httpRequestBlob('POST', `/crm_order/get-return-order-by-date`, data);
		} else {
			return this.httpRequest('POST', `/crm_order/get-return-order-by-date`, data);
		}
	}

	// get order by status
	getCrmOrdersByStatus(data) {
		delete data?.search_type;
		return this.httpRequest('POST', `/crm_order/get-order-by-status`, data);
	}
	// get order by status download
	crmOrdersStatusDownload(data) {
		delete data?.search_type;
		return this.httpRequestBlob('POST', `/crm_order/get-order-by-status-download`, data);
	}
	// get order by status
	getCrmReturnOrdersByStatus(data) {
		delete data?.search_type;
		return this.httpRequest('POST', `/crm_order/get-return-order-by-status`, data);
	}

	//get order details
	getCrmOrdersByID(id) {
		return this.httpRequest('GET', `/crm_order/get-order/${id}`);
	}

	// get return order details
	getCrmOrdersReturnByID(id) {
		return this.httpRequest('GET', `/crm_order/get-return-order/${id}`);
	}
	// Update shipping address (CRM)
	updateShippingAddress(data) {
		return this.httpRequest('POST', `/crm_order/update-order-address`, data);
	}

	// order confirm (CRM)
	orderConfirm(data) {
		return this.httpRequest('POST', `/crm_order/create-order-confirm`, data);
	}
	// Orders Count (CRM)
	getOrdersCount(data) {
		return this.httpRequest('POST', `/dashboard/crm/get-order-count`, data);
	}

	// Recent Orders (CRM)
	recentOrders() {
		return this.httpRequest('GET', `/dashboard/crm/get-recent-order`);
	}

	// Chart api get-sale-summary  (CRM)
	getSaleSummary(key = 'daily') {
		return this.httpRequest('GET', `/dashboard/crm/get-sale-summary/${key}`);
	}

	// Chart api top selling products (CRM)
	getTopSelling(key = 'daily') {
		return this.httpRequest('GET', `/dashboard/crm/get-top-selling-product/${key}`);
	}

	// cancel request (CRM)
	orderCancelRequest(data) {
		return this.httpRequest('POST', `/crm_order/update-cancel-request-order`, data);
	}

	// order cancel items (CRM)
	orderCancelItems(data) {
		return this.httpRequest('POST', `/crm_order/update-order-cancel`, data);
	}

	// order cancel items (CRM)
	markOrderUndelivered(data) {
		return this.httpRequest('POST', `/crm_order/mark-undelivered`, data);
	}

	// mark order returned items (CRM)
	markOrderReturned(data) {
		return this.httpRequest('POST', `/crm_order/mark-returned`, data);
	}

	// order refund recanculation
	cancelOrderRefund(data) {
		return this.httpRequest('POST', `/crm_order/recalculate-cancel-order/${data?.order_no}`, data);
	}

	// Return order refund recanculation
	returnOrderRefund(data) {
		return this.httpRequest('POST', `/crm_order/recalculate-return`, data);
	}

	// Return order item
	returnOrderItem(data) {
		return this.httpRequest('POST', `/crm_order/add-return`, data);
	}
	// Return depot order item
	returnDepotOrderItem(data) {
		return this.httpRequest('POST', `/crm_order/add-depot-return`, data);
	}
	cancelReturnDepotOrderItem(data) {
		return this.httpRequest('POST', `/crm_order/cancel-depot-return`, data);
	}
	rejectReturn(data) {
		return this.httpRequest('POST', `/crm_order/reject-depot-return`, data);
	}

	acceptReturn(data) {
		return this.httpRequest('POST', `/crm_order/accept-depot-return`, data);
	}
	markAsPickup(data) {
		return this.httpRequest('POST', `/crm_order/pickup-depot-return`, data);
	}

	/**
	 * Delete Tag API Call
	 * @param {*} data
	 * @returns
	 */
	cancelReturnItem(data) {
		return this.httpRequest('DELETE', `/crm_order/cancel-return`, data);
	}

	// Return order item
	generateOTPReturn(data) {
		return this.httpRequest('POST', `/crm_return_order/generate-return-otp`, data);
	}

	getAparajitaData(url) {
		let endpoint = '/report/get-all-Aparajita/';

		if (url?.page !== undefined && url?.pageSize !== undefined) {
			endpoint += `${url.page}/${url.pageSize}`;
		}

		return this.httpRequest('GET', endpoint);
	}

	getSpecialWomenRegistrationReport({page = 0, pageSize = 10, searchTerm, is_download} = {}) {
		const params = new URLSearchParams();

		if (searchTerm) params.append('searchTerm', searchTerm);
		if (is_download) params.append('is_download', 'true');

		const query = params.toString();
		return this.httpRequest(
			'GET',
			`/special-women-report/get-all-special-women-registration/${page}/${pageSize}${query ? `?${query}` : ''}`
		);
	}

	getRupantaranDelhiData(url) {
		let endpoint = '/report/get-all-rupantaran-yatra-delhi/';

		if (url?.page !== undefined && url?.pageSize !== undefined) {
			endpoint += `${url.page}/${url.pageSize}`;
		}

		// Add is_submitted query parameter
		const queryParams = new URLSearchParams();
		if (url?.is_submitted !== undefined) {
			queryParams.append('is_submitted', url.is_submitted);
		}

		const queryString = queryParams.toString();
		if (queryString) {
			endpoint += `?${queryString}`;
		}

		return this.httpRequest('GET', endpoint);
	}

	// Return order item
	// validateOtpReturn(data) {
	//   return this.httpRequest("POST", `/crm_return_order/create-new-online-return`, data);
	// }

	createInvoiceDepot(data) {
		return this.httpRequest('POST', `/crm_order/create-invoice`, data);
	}

	getShippingChargesForDepot(data) {
		return this.httpRequest('POST', `/crm_order/shipping-charges`, data);
	}

	// Ship rocket api

	addShipRocketApi(data) {
		return this.httpRequest('POST', `/ship-rocket/create`, data);
	}
	addShipRocketReturnApi(data, isManual) {
		return this.httpRequest('POST', `/ship-rocket/create-return?isManual=${isManual}`, data);
	}

	UpdateDetailsShipRocketDetails(data) {
		return this.httpRequest('PUT', `/ship-rocket/update`, data);
	}

	getCourierList(id, cust_id, depot_id) {
		return this.httpRequest('GET', `/ship-rocket/couriers/${id}/${cust_id}/${depot_id}`);
	}

	shipRocketCancelOrderById(data) {
		return this.httpRequest('POST', `/ship-rocket/cancel`, data);
	}
	// Assign Awb
	AssignAwbShipRocketApi(data) {
		return this.httpRequest('POST', `/ship-rocket/generate-awb`, data);
	}

	// Ship Rocket Download Order Invoice
	shipRocketDownloadInvoice(data) {
		return this.httpRequest('POST', `/ship-rocket/order/print-invoice`, data);
	}

	// Get Pickup date schedule
	apiPickupScheduleDate(data) {
		return this.httpRequest('POST', `/ship-rocket/schedule-pickup`, data);
	}

	// Generate label
	shipRocketGenerateLabel(data) {
		return this.httpRequest('POST', `/ship-rocket/generate-label`, data);
	}

	// GET single order details (Ship rocket)
	getShipRocketSingleOrder(id, depot_id) {
		return this.httpRequest('GET', `/ship-rocket/order/${id}/${depot_id}`);
	}
	// Download manifest shiprocket
	downloadManifestShipRocket(data) {
		return this.httpRequest('POST', `/ship-rocket/order/manifest`, data);
	}

	//-----------------------------------------------crm api end----------------------------------------------------------------------

	// pincode-area-map : create single pincode area map data
	addEditPincodeAreaMapping(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/pincode_area_maps/${id}`, data);
		} else {
			return this.httpRequest('POST', `/pincode_area_maps`, data);
		}
	}

	// pincode-area-map : get single pincode area map data
	getSinglePincodeAreaData(id) {
		return this.httpRequest('GET', `/pincode_area_maps/${id}`);
	}

	// pincode-area-map : delete pincode area map data
	deletePincodeAreaMapping(data) {
		return this.httpRequest('DELETE', `/pincode_area_maps`, data);
	}

	//
	getStorePincodeAreaList(val) {
		return this.httpRequest('GET', `/pincode_area_maps/all/0/200?searchTerm=${val}`);
	}

	// download-category : add/edit
	addEditDownloadCategory(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/download_categories/${id}`, data);
		} else {
			return this.httpRequest('POST', `/download_categories`, data);
		}
	}

	// download-category : get single download category data
	getSingleDownloadCategory(id) {
		return this.httpRequest('GET', `/download_categories/${id}`);
	}

	// download-category : delete download-category
	deleteDownloadCategory(data) {
		return this.httpRequest('DELETE', `/download_categories`, data);
	}

	// download-language : add/edit
	addEditDownloadLanguage(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/download_language/${id}`, data);
		} else {
			return this.httpRequest('POST', `/download_language`, data);
		}
	}

	// download-language  : get single download language  data
	getSingleDownloadLanguage(id) {
		return this.httpRequest('GET', `/download_language/${id}`);
	}

	// download-language  : delete download-language
	deleteDownloadLanguage(data) {
		return this.httpRequest('DELETE', `/download_language`, data);
	}

	// content-type : add/edit content-type
	addEditContentType(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/content_type/${id}`, data);
		} else {
			return this.httpRequest('POST', `/content_type`, data);
		}
	}

	// content-type  : get single content-type  data
	getSingleContentType(id) {
		return this.httpRequest('GET', `/content_type/${id}`);
	}

	// content-type  : delete content-type
	deleteContentType(data) {
		return this.httpRequest('DELETE', `/content_type`, data);
	}

	// download-content : get All download categories for dropdown
	getAllDownloadCategoriesForDropDown() {
		return this.httpRequest('GET', `/downloads/download-categories/all/0/100`);
	}

	// download-content : get All download categories for dropdown
	getAllDownloadLanguagesForDropDown() {
		return this.httpRequest('GET', `/downloads/download-languages/all/0/100`);
	}

	// download-content : get All download categories for dropdown
	getAllContentTypeForDropDown() {
		return this.httpRequest('GET', `/downloads/content-type/all/0/100`);
	}

	// voucher : add/edit
	addEditVoucher(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/voucher/${id}`, data);
		} else {
			return this.httpRequest('POST', `/voucher`, data);
		}
	}

	// voucher : get single voucher details
	getSingleVoucherData(id) {
		return this.httpRequest('GET', `/voucher/${id}`);
	}

	// voucher : delete voucher
	deleteDVoucher(data) {
		return this.httpRequest('DELETE', `/voucher`, data);
	}

	// get zones list
	getZonesList() {
		return this.httpRequest('GET', `/generic/all-zones`);
	}

	// get states list
	getStatesListBasedOnZone(val) {
		return this.httpRequest('GET', `/generic/zonal-states?searchTerm=${val}`);
	}

	// get districts list
	getSDistrictListBasedOnState(val) {
		return this.httpRequest('GET', `/generic/state-wise-districts/?searchTerm=${val}`);
	}

	// rcm events: add/edit events
	addEditEvent(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/rcm-event/${id}`, data);
		} else {
			return this.httpRequest('POST', `/rcm-event`, data);
		}
	}

	// rcm events : get single event details
	getEventData(id) {
		return this.httpRequest('GET', `/rcm-event/${id}`);
	}

	// rcm events: delete event
	deleteEvent(data) {
		return this.httpRequest('DELETE', `/rcm-event`, data);
	}

	// add ulp targets
	addULPTargets(data) {
		return this.httpRequest('POST', `/ulp-target/add`, data);
	}
	// get ulp targets
	getTargets(data) {
		return this.httpRequest('GET', `/ulp-target/all/${data}`);
	}

	// get states list
	getStatesList() {
		return this.httpRequest('GET', `/generic/zonal-states`);
	}

	// meeting: add/edit meeting
	addEditMeeting(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/meeting/${id}`, data);
		} else {
			return this.httpRequest('POST', `/meeting`, data);
		}
	}

	// meeting : get single meeting details
	getMeetingData(id) {
		return this.httpRequest('GET', `/meeting/${id}`);
	}

	// meeting: delete meeting
	deleteMeeting(data) {
		return this.httpRequest('DELETE', `/meeting`, data);
	}

	// marketing-plan-language : add/edit
	addEditMarketingPlanLanguage(data, id, multiPart = true) {
		if (id) {
			return this.httpRequest('PUT', `/marketing_plan_language/${id}`, data, {
				multiPart,
			});
		} else {
			return this.httpRequest('POST', `/marketing_plan_language`, data, {
				multiPart,
			});
		}
	}

	// marketing-plan-language  : get single marketing-plan-language  data
	getSingleMarketingPlanLanguage(id) {
		return this.httpRequest('GET', `/marketing_plan_language/${id}`);
	}

	// marketing-plan-language  : delete marketing-plan-language
	deleteMarketingPlanLanguage(data) {
		return this.httpRequest('DELETE', `/marketing_plan_language`, data);
	}

	// marketing-plan-language : get marketing plan languages list
	getMarketingPlanLanguage() {
		return this.httpRequest('GET', `/marketing_plan_language/all/0/100`);
	}

	// marketing-plan : add/edit marketing-plan
	addEditMarketingPlan(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/marketing_plan/${id}`, data);
		} else {
			return this.httpRequest('POST', `/marketing_plan`, data);
		}
	}

	// marketing-plan : get single marketing-plan data
	getSingleMarketingPlan(id) {
		return this.httpRequest('GET', `/marketing_plan/${id}`);
	}

	// marketing-plan : delete marketing-plan
	deleteMarketingPlan(data) {
		return this.httpRequest('DELETE', `/marketing_plan`, data);
	}

	// marketing-plan : get marketing-plan list
	getMarketingPlan() {
		return this.httpRequest('GET', `/marketing_plan/all`);
	}

	// product language : add/edit
	upudateProductLanguages(id, data) {
		return this.httpRequest('PUT', `/products/product_languages/${id}`, data);
	}

	// product language : get
	getProductLanguages(id) {
		return this.httpRequest('GET', `/products/product_languages/${id}`);
	}

	// size-chart : add/edit size-chart
	addSizeChart(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/size_chart/${id}`, data);
		} else {
			return this.httpRequest('POST', `/size_chart`, data);
		}
	}

	// size-chart : get single size-chart  data
	getSingleSizeChartDetail(id) {
		return this.httpRequest('GET', `/size_chart/${id}`);
	}

	// size-chart : delete size-chart
	deleteSizeChart(data) {
		return this.httpRequest('DELETE', `/size_chart`, data);
	}

	// general-pages : add/edit general-pages
	addGeneralPage(data, id) {
		if (id) {
			return this.httpRequest('PUT', `/general_page/${id}`, data);
		} else {
			return this.httpRequest('POST', `/general_page`, data);
		}
	}

	// size-chart : get all size-chart data
	getAllSizeChartList() {
		return this.httpRequest('GET', `/size_chart/all/0/100`);
	}

	// general-pages : get all general-pages data
	getAllSizeCharts() {
		return this.httpRequest('GET', `/general_page/all/0/100`);
	}

	// general-pages : get single general-pages  data
	getSingleGeneralDetail(id) {
		return this.httpRequest('GET', `/general_page/${id}`);
	}
	// API Call to post KeySoul basic detail

	keySoulCreateBasicDetail(data, multiPart = true) {
		return this.httpRequest('POST', `/brands/brand-template/add-basic-detail`, data, {
			multiPart,
		});
	}

	// API Call to post KeySoul Program Detail
	keySoulCreateProgramDetail(data, multiPart = true) {
		return this.httpRequest('POST', `/brands/brand-template/add-program-detail`, data, {
			multiPart,
		});
	}

	// API Call to create or update key soul Social Link
	keySoulCreateOrUpdateSocialLink(brandId, data) {
		return this.httpRequest('POST', `/brands/brand-template/add-update-social-links/${brandId}`, data);
	}

	// API Call to create or update key soul Social Link
	getKeySoulSocialLink(brandId, platform_type) {
		return this.httpRequest('GET', `/brands/brand-template/get-social-links/${brandId}/${platform_type}`, null);
	}

	// API Call to post KeySoul blog Detail
	keySoulCreateBlogDetail(data, multiPart = true) {
		return this.httpRequest('POST', `/brands/brand-template/add-blog-detail`, data, {
			multiPart,
		});
	}

	// API Call to fetch Key Soul Program Detail
	getKeySoulProgramDetail(id, type, platform_type) {
		return this.httpRequest('GET', `/brands/brand-template/get-program-detail/${id}/${type}/${platform_type}`);
	}

	// API Call to fetch Key Soul Blog Detail
	getKeySoulBlogDetail(id, type, platform_type) {
		return this.httpRequest('GET', `/brands/brand-template/get-blog-detail/${id}/${type}/${platform_type}`);
	}
	// API Call to fetch Key Soul Blog Detail
	getBrandBasicDetails(id, page, pageSize, searchTerm) {
		return this.httpRequest(
			'GET',
			`/brands/brand-template/get-all-basic-detail/${id}?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}`
		);
	}

	// API Call to fetch Key Soul all list
	getAllTemplateData(page, pageSize, searchTerm) {
		return this.httpRequest(
			'GET',
			`/brands/brand-template/get-all-brand-templates-data?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}`
		);
	}

	// API Call to fetch products by brand
	getProductsByBrand(id, searchTerm) {
		return this.httpRequest('GET', `/brands/get-all-products/${id}?searchTerm=${searchTerm}`);
	}

	// API Call to fetch best seller products by brand
	getBestSellerProductsById(id) {
		return this.httpRequest('GET', `/brand-best-seller-products/get-best-seller/${id}`);
	}

	// API Call to update basic detail
	keySoulUpdateBasicDetail(data, id, multiPart = true) {
		return this.httpRequest('PUT', `/brands/brand-template/edit-basic-detail/${id}`, data, {
			multiPart,
		});
	}
	// API Call to delete basic detail
	keySoulDeleteBasicDetail(id) {
		return this.httpRequest('DELETE', `/brands/brand-template/delete-basic-detail/${id}`, null);
	}

	// Key Soul Update Program Detail
	keySoulUpdateProgramDetail(data, multiPart = true) {
		return this.httpRequest('PUT', `/brands/brand-template/edit-program-detail`, data, {
			multiPart,
		});
	}
	// Key Soul Update Blog Detail
	keySoulUpdateBlogDetail(data, multiPart = true) {
		return this.httpRequest('PUT', `/brands/brand-template/edit-blog-detail`, data, {
			multiPart,
		});
	}

	// Key Soul Create Testimonial
	keySoulCreateTestimonialsDetail(data, multiPart = true) {
		return this.httpRequest('POST', '/brands/brand-template/add-testimonial', data, {
			multiPart,
		});
	}

	// Key Soul Update Testimonial
	keySoulUpdateTestimonialsDetail(data, id, multiPart = true) {
		return this.httpRequest('PUT', `/brands/brand-template/edit-testimonial/${id}`, data, {
			multiPart,
		});
	}

	// API Call to fetch Key Soul Testimonial Detail
	getKeySoulTestimonialsDetail(id, type, platform_type) {
		return this.httpRequest('GET', `/brands/brand-template/get-all-testimonial/${id}/${platform_type}`);
	}

	// API Call to Fetch Key Soul Basic detail
	getKeySoulBasicDetail(id) {
		return this.httpRequest('GET', `/brands/brand-template/get-basic-detail/${id}`);
	}
	// API Call to Fetch Key Soul Basic detail
	deleteKeySoulTestimonial(id) {
		return this.httpRequest('DELETE', `/brands/brand-template/delete-testimonial/${id}`);
	}

	// API call to create or update best seller products
	addBestSeller(data, id) {
		return this.httpRequest('POST', `/brands/add-edit/${id}`, data);
	}

	// about us - history : add/edit about us history
	addEditAboutUsHistory(id, data, multiPart = true) {
		if (id) {
			return this.httpRequest('PUT', `/about-us-history/${id}`, data, {multiPart});
		} else {
			return this.httpRequest('POST', `/about-us-history`, data, {multiPart});
		}
	}

	// about us - history : get single about us history
	getSingleAboutUsHistory(id) {
		return this.httpRequest('GET', `/about-us-history/${id}`);
	}

	// about us - history : delete about us  history
	deleteSingleAboutUsHistory(data) {
		return this.httpRequest('DELETE', `/about-us-history`, data);
	}

	// notices : add/edit notice
	addEditNotice(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/notice/${id}`, data);
		} else {
			return this.httpRequest('POST', `/notice`, data);
		}
	}

	// notices : get single notice details
	getNoticeData(id) {
		return this.httpRequest('GET', `/notice/${id}`);
	}
	// Notifications get single show on details
	getShowOnNotificationData(id) {
		return this.httpRequest('GET', `/notice/show-on/data`);
	}

	// notices : delete notice
	deleteNotice(data) {
		return this.httpRequest('DELETE', `/notice`, data);
	}

	// --------------------------------------------------------------------
	// ---------------------------- KYC Admin -----------------------------
	// --------------------------------------------------------------------

	// search Ab Details : get ab details by bank acnt no
	getAbDetailsByBankAccNo(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/bank`, data);
	}
	// search Ab Details : get ab details by mob no
	getAbDetailsByMobNo(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/mobile`, data);
	}
	// search registered buyer details
	getRegisteredBuyerForSearch(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/search-info/registered-buyer${params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''}`,
			payload
		);
	}

	// SMS delivery status logs - date range + optional mobile + pagination
	getSmsDeliveryLogs(data) {
		return this.httpRequest('POST', `/kyc-admin/sms-delivery-status/get-logs`, data);
	}

	// SMS delivery status - check live status for a single message by mtalk id
	checkSmsDeliveryStatus(data) {
		return this.httpRequest('POST', `/kyc-admin/generic/sms-status-by-id`, data);
	}

	// search Ab Details : get ab details by display wall ab no
	getAbDetailsByDisplayWallAB(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/dw-ab-no`, data);
	}

	// search Ab Details : get ab details by email id
	getAbDetailsByEmailId(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/email-id`, data);
	}
	// search Ab Details : get ab details by pan no
	getAbDetailsByPanNo(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/pan`, data);
	}
	// search Ab Details : get ab details by aadhar no
	getAbDetailsByAadharNo(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/aadhar`, data);
	}
	// generic : get ab details by ab no
	getAbDetailsByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/generic/ab-details`, data);
	}

	// get KYC status for an AB
	getKycStatus(data) {
		return this.httpRequest('GET', `/report/ab-kyc-status?ab_id=` + data);
	}
	// associate buyer : stop AB ID
	stopABID(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-id-stop/`, data);
	}
	// associate buyer : get ab details by ab no
	getAssociateDetailsByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/get`, data);
	}

	// associate buyer : get ab gst list
	getABGstList(data) {
		return this.httpRequest('POST', `/kyc-super-admin/gst-no/get-list`, data);
	}

	// Kyc track : get master ab details by ab no
	getMasterABDetailsByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-details`, data);
	}

	// kyc track : get kyc status track by ab no
	getKycStatusTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-kyc-status-track`, data);
	}

	// kyc track : get terminated track by ab no
	getTerminationTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-terminated-track`, data);
	}

	// kyc track : get address track by ab no
	getAddressTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-address-track`, data);
	}

	// kyc track : get mobile track by ab no
	getMobileTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-mobile-track`, data);
	}

	// kyc track : get email track by ab no
	getEmailTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-email-track`, data);
	}

	// kyc track : get nominee track by ab no
	getNomineeTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-nominee-track`, data);
	}

	// kyc track : get personal track by ab no
	getPersonalTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-personal-track`, data);
	}

	// kyc track : get name track by ab no
	getNameTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-name-track`, data);
	}

	// kyc track : get bank track by ab no
	getBankTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-bank-track`, data);
	}

	// kyc track : get pan track by ab no
	getPanTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-pan-track`, data);
	}

	// kyc track : get stop track by ab no
	getStopTrackByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-tracks/master-ab-details/get-stop-track`, data);
	}

	// associate buyer : get gst number by ab no
	getABDetailByGstNo(data) {
		return this.httpRequest('POST', `/kyc-super-admin/gst-no/get-details`, data);
	}

	//Close gst => close gstno for ab
	closeABGstNo(data, multiPart = true) {
		return this.httpRequest('POST', `/kyc-super-admin/gst-no/close-gst`, data, {multiPart});
	}

	getABDetailForStopKyc(data) {
		return this.httpRequest('POST', `/kyc-super-admin/stop-kycs/get`, data);
	}

	// Exceptional Cases APIs
	getExceptionalCasesList(params) {
		const queryParams = new URLSearchParams(params || {}).toString();
		return this.httpRequest(
			'GET',
			`/kyc-super-admin/exceptional-cases/list${queryParams ? `?${queryParams}` : ''}`
		);
	}

	addExceptionalCase(data) {
		return this.httpRequest('POST', `/kyc-super-admin/exceptional-cases/add`, data);
	}

	removeExceptionalCase(distNo) {
		return this.httpRequest('DELETE', `/kyc-super-admin/exceptional-cases/remove/${distNo}`);
	}

	// red kyc => get ab detail
	getABDetailForRedKyc(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/red-kyc-report/get`, data);
	}

	// red kyc => get red kyc downline
	getRedKycDownline(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/red-kyc-report/get-downline`, data);
	}

	// red kyc => delete ab
	deleteABForRedKyc(data) {
		return this.httpRequest('DELETE', `/kyc-admin/reports/red-kyc-report/delete`, data);
	}

	// red kyc => add ab
	addRedKyc(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/red-kyc-report/add`, data);
	}

	// associate buyer : reset passwrd
	resetABPswrd(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/reset-pass`, data);
	}

	// associate buyer : assocaite buyer details - Ab Ledger
	getABLedgerData(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/ledger`, data);
	}

	// associate buyer : assocaite buyer details - Ab Wallet
	getABWalletData(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/wallet`, data);
	}

	// associate buyer : assocaite buyer details - Ab Wallet Transaction Details
	getABWalletTxnDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/wallet/details`, data);
	}

	// associate buyer : assocaite buyer details - Ab Repurchase
	getABRepurchaseData(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/repurchase/summary`, data);
	}
	// associate buyer : assocaite buyer details - AB Re-Purchase Details
	getABRepurchaseDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/repurchase/details`, data);
	}
	// AB Business Info API methods
	getAbBusinessInfoDetails(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/get`, data);
	}
	getAbBusinessInfoLedgerData(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/ledger`, data);
	}
	getAbBusinessInfoRepurchaseData(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/repurchase/summary`, data);
	}
	getAbBusinessInfoRepurchaseDetails(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/repurchase/details`, data);
	}
	getAbBusinessInfoRepurchaseBillItemsData(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/repurchase/bill-items`, data);
	}
	getAbBusinessInfoCurrentBusiness(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/current-business/self-bus`, data);
	}
	getAbBusinessInfoCurrentBusinessDownLine(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/current-business/down-bus`, data);
	}
	getAbBusinessInfoCommission(data) {
		return this.httpRequest('POST', `/accounts/ab-business-info/ab-commission`, data);
	}

	// associate buyer : assocaite buyer details - Ab Uptree
	getAbDetailsForUptree(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/uptree/`, data);
	}

	// associate buyer : check monthly meetings
	getMonthlyMeeting(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/monthly-meetings/get-all`, data);
	}

	// associate buyer : check monthly meeting details by id
	getMonthlyMeetingDetailsById(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/monthly-meetings/details`, data);
	}

	// associate buyer : update monthly meeting status
	meetingStatusUpdate(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/monthly-meetings/update-status`, data);
	}
	// associate buyer : assocaite buyer details - Ab Repurchase summary
	getABRepurchaseSummaryDetail(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/repurchase/summary`, data);
	}

	// associate buyer : assocaite buyer details - Ab Repurchase
	getAbRepurhaseRowDetailData(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/repurchase/details`, data);
	}

	// associate buyer : AB Not Purchase OTP - GET the AB Details For OTP Check
	getABDetailsForOtpCheck(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/not-purchase-otp/`, data);
	}

	// associate buyer : AB Not Purchase OTP - Update the AB Details For OTP Check
	updateABDetailsForOtpCheck(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/not-purchase-otp/update/`, data);
	}

	// Delete Info: get bank account details
	getBankAccountDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank/get-ab-for-bank-details`, request);
	}

	// Delete Info: delete bank account details
	deleteBankAccountDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank/update-bank-details-check`, request);
	}

	// Fetch enabled bank account details before disabling
	getEnabledBankAccountForDisable(request) {
		return this.httpRequest('POST', `/kyc-admin/disable-info/bank-acc/get-ab-for-bank-details`, request);
	}

	// Disable bank account details so user can re-upload
	disableBankAccountDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/disable-info/bank-acc/update-bank-details-check`, request);
	}

	// Fetch enabled PAN details before disabling
	getEnabledPanAccountForDisable(request) {
		return this.httpRequest('POST', `/kyc-admin/disable-info/pan-no/get-ab-for-pan-details`, request);
	}

	// Disable PAN details so user can re-upload
	disablePanAccountDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/disable-info/pan-no/update-pan-details-check`, request);
	}

	// Delete Info: get pan number details
	getPANNumberDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/pan/get-ab-for-pan-details`, request);
	}

	deletePANNumberDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/pan/update-pan-details-check`, request);
	}

	// Delete Info: get AB profile photo
	getABProfilePhoto(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/ab-photo/get-ab-for-profile-photo`, request);
	}

	// Delete Info: delete AB profile photo
	deleteABProfilePhoto(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/ab-photo/delete-ab-photo`, request);
	}

	// Report => kyc declaration report
	kycDeclarationReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/declaration-report`, data);
	}
	// Report => Kyc details report
	kycDetailsReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/detail-report`, data);
	}

	// KYC : get-identity-proof
	getIdentityProof() {
		return this.httpRequest('GET', `/kyc/get-identity-proof`);
	}

	// KYC : get-address-proof
	getAddressProof() {
		return this.httpRequest('GET', `/kyc/get-address-proof`);
	}

	// Report => Kyc Not Ok Report
	kycNotOKReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/not-ok-report`, data);
	}

	// Report => Kyc  Current business
	kycCurrentBusiness(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/current-business/self-bus`, data);
	}
	//  Report => Kyc  Current business => down line
	kycCurrentBusinessDownLine(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/current-business/down-bus`, data);
	}

	// Report => Kyc feeding user
	getKycFeeding(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/feed-user/get-details`, data);
	}

	// Declaration => mobile declaration
	mobileDeclaration(data) {
		return this.httpRequest('POST', `/kyc-admin/declaration/mobile/update-mobile`, data);
	}
	// generic : financial years list
	getFinancialYearsList() {
		return this.httpRequest('GET', `/kyc-admin/generic/available-fiscal-years`);
	}

	// associate buyer : ab stop payment details
	getAbStopPaymentDetails(data, page, pageSize, searchTerm) {
		let url = `/kyc-admin/associate-buyer/payment-details/${page}/${pageSize}`;

		// Append the searchTerm if provided
		if (searchTerm) {
			url += `?searchTerm=${searchTerm}`;
		}

		return this.httpRequest('POST', url, data);
	}

	//  Reports => terminate repurchase report
	listTerminateRepurchase(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/terminate-repurchase`, data);
	}

	// List => monthly meeting Report
	listMonthlyMeetingReport(data) {
		return this.httpRequest('POST', `/kyc-admin/lists/download-monthly-meetings/get-all`, data);
	}
	// KYC - Get Simialar Entities
	getKycSimilarEntities(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/similar-kyc`, data);
	}

	// KYC - Get Matching Entities
	getKycMatchingEntities(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/matching-kyc/get-details`, data);
	}

	// KYC - Get KYC New Entry
	getKycNewEntryDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/new-entry/get-details`, data);
	}

	// KYC - Get KYC Instant Approval
	getKycInstantApprovalDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/instant-approval/get-details`, data);
	}

	// KYC - Update KYC Instant Approval
	updateInstantApprovalStatus(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/instant-approval/update-status`, data);
	}

	// KYC - Get KYC Todays Users
	getKycTodaysUsersDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/todays-users/get-details`, data);
	}

	// KYC - Get KYC Old Entry
	getKycOldEntryDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/old-entry/get-details`, data);
	}

	// KYC - Get KYC Rejection Reasons
	getKYCRejectionReasons() {
		return this.httpRequest('GET', `/kyc-admin/generic/reject-reason`);
	}

	// KYC - Get AB Name By AB No
	getABNameByABNo(dist_no) {
		return this.httpRequest('GET', `/kyc-admin/generic/ab-name-by-ab-no?dist_no=${dist_no}`);
	}

	// KYC - Get KYC Rejection Reasons For Verification
	getKycVerificationRejectionReasons() {
		return this.httpRequest('GET', `/kyc-admin/generic/verification-reject-reason`);
	}

	// KYC - Update New Entry KYC Status
	updateNewKycStatus(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/new-entry/update-status`, data);
	}

	// KYC - Update Old Entry KYC Status
	updateOldKycStatus(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/old-entry/update-details`, data);
	}

	// compliance documents : add/edit compliance documents
	addUpdateComplianceDocuments(id, data, multiPart = true) {
		if (id) {
			return this.httpRequest('PUT', `/compliance_documents/${id}`, data, {multiPart});
		} else {
			return this.httpRequest('POST', `/compliance_documents`, data, {multiPart});
		}
	}

	// compliance documents : get single  compliance documents data
	getSingleComplianceDocumentsData(id) {
		return this.httpRequest('GET', `/compliance_documents/${id}`);
	}

	// compliance documents : delete compliance documents
	deleteSingleComplianceDocuments(data) {
		return this.httpRequest('DELETE', `/compliance_documents`, data);
	}

	// faqs : add/edit faqs
	addUpdateFaqs(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/faqs/${id}`, data);
		} else {
			return this.httpRequest('POST', `/faqs`, data);
		}
	}

	// employee : add/edit employee
	addUpdateEmployee(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/employee/update`, data);
		} else {
			return this.httpRequest('POST', `/employee/add`, data);
		}
	}

	// employees : delete employees
	deleteEmployee(data) {
		return this.httpRequest('POST', `/employee/delete`, data);
	}

	// faqs : get single faqs data
	getSingleFaqsData(id) {
		return this.httpRequest('GET', `/faqs/${id}`);
	}

	// employee : get single employee data
	getSingleEmployeeData(id) {
		return this.httpRequest('GET', `/employee/by-id/${id}`);
	}

	// bank : get all bank list
	getBankList(apiUrl, payload) {
		return this.httpRequest('POST', `${apiUrl}`, payload);
	}

	// bank : get single bank data
	getSingleBankData(id) {
		return this.httpRequest('GET', `/bank/by-id/${id}`);
	}

	// bank : add/edit bank
	addUpdateBank(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/bank/update`, data);
		} else {
			return this.httpRequest('POST', `/bank/add`, data);
		}
	}

	// branches : get all branches list
	getBranchList(apiUrl, payload) {
		return this.httpRequest('POST', `${apiUrl}`, payload);
	}

	// branches : get single branches data
	getSingleBranchData(id) {
		return this.httpRequest('GET', `/branches/by-id/${id}`);
	}

	// branches : add/edit branches
	addUpdateBranch(id, data) {
		if (id) {
			return this.httpRequest('PUT', `/branches/update`, data);
		} else {
			return this.httpRequest('POST', `/branches/add`, data);
		}
	}

	// faqs : delete faqs
	deleteSingleFaqs(data) {
		return this.httpRequest('DELETE', `/faqs`, data);
	}

	// lists : get technical leader details by ab no
	getTechnicalLeaderDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/lists/leader-tree`, data);
	}
	// lists : get technical leader downline
	getTechnicalLeaderDownlineDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/lists/leader-tree/downline`, data);
	}

	//  List => technical core leaders
	getTechnicalCoreLeaders(data) {
		return this.httpRequest('POST', `/kyc-admin/lists/technical-core-list/get-core-list`, data);
	}

	//  List => Get E-Kyc List Options
	getEkycListDropdown() {
		return this.httpRequest('GET', `/kyc-admin/generic/ekyc-list-dropdown`);
	}

	//  List => Get E-Kyc List Options
	getEkycListByType(data) {
		return this.httpRequest('POST', `/kyc-admin/lists/ekyc-list/get-details`, data);
	}

	// Associate Buyer => Get the available years
	getPurchaseDownloadAvailableYears() {
		return this.httpRequest('GET', `/kyc-admin/associate-buyer/ab-purchase-download/available-years`);
	}

	// Associate Buyer => Get the available months
	getPurchaseDownloadAvailableMonths() {
		return this.httpRequest('GET', `/kyc-admin/associate-buyer/ab-purchase-download/available-months`);
	}

	// Associate Buyer => Get the AB Purchase Download Report
	getPurchaseDownloadReport(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-purchase-download/`, data);
	}
	// Associate Buyer => Sms Diamond Club
	getSmsDiamondClub(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/sms-diamond-club/send`, data);
	}

	// Terminate : get ab details
	getAbDetailsForTermination(data) {
		return this.httpRequest('POST', `/kyc-admin/terminate-mod/insert/get-details`, data);
	}

	// Terminate : update termination status of AB
	updateABTerminationStatus(data) {
		return this.httpRequest('POST', `/kyc-admin/terminate-mod/insert/update-status`, data);
	}

	// soft terminate : soft terminate associate buyer
	getUserForSoftTermination(data) {
		return this.httpRequest('POST', `/kyc-admin/terminate-mod/executive-feed/get-details`, data);
	}

	// soft terminate : soft terminate associate buyer
	softTerminateUser(data) {
		return this.httpRequest('POST', `/kyc-admin/terminate-mod/executive-feed/update-status`, data);
	}

	// document update => Ab photo update
	getABPhotoUpdate(data) {
		return this.httpRequest('POST', `/kyc-admin/doc-update/ab-photo-update/check-ab-photo`, data);
	}
	// document update => Ab photo update
	getABPhotoUpload(data, multiPart = true) {
		const distNo = data instanceof FormData ? data.get('dist_no') : data?.dist_no;
		return this.httpRequest('POST', `/kyc-admin/doc-update/ab-photo-update?dist_no=${distNo}`, data, {
			multiPart,
		});
	}
	// document update : get ab details by ab no
	getDocUpdateAbDetailsByAbNo(data) {
		return this.httpRequest('POST', `/kyc-admin/doc-update/pan-update/ab-details`, data);
	}
	// document update : add pan details
	addPanDetails(data, multiPart = true) {
		const distNo = data instanceof FormData ? data.get('dist_no') : data?.dist_no;
		return this.httpRequest('POST', `/kyc-admin/doc-update/pan-update?dist_no=${distNo}`, data, {
			multiPart,
		});
	}

	// generic: API call to get identity proof list
	getGenericIdentityProofList() {
		return this.httpRequest('GET', `/kyc-admin/generic/get-identity-proof`);
	}

	// generic : API call to get address proof list
	getGnenericAddressProofList() {
		return this.httpRequest('GET', `/kyc-admin/generic/get-address-proof`);
	}

	// document update : add pan details
	updateAbAddressAndIdProof(data, multiPart = true) {
		const distNo = data instanceof FormData ? data.get('dist_no') : data?.dist_no;
		return this.httpRequest('POST', `/kyc-admin/doc-update/address-id-proof?dist_no=${distNo}`, data, {multiPart});
	}

	// bank update requests : get all bank update requests
	getAllBankUpdateRequests() {
		return this.httpRequest('POST', `/kyc-admin/update-req/bank/get-all`);
	}

	// purchase rule : get all purchase rule list
	getAllPurchaseRuleList() {
		return this.httpRequest('GET', `/purchase-rules/all`);
	}

	// purchase rule : create purchase rule
	createPurchaseRule(data) {
		return this.httpRequest('POST', `/purchase-rules/add`, data);
	}

	// generic : get product name by sap code
	getProductBySapCode(sapCode) {
		return this.httpRequest('GET', `/generic/product-name/${sapCode}`);
	}

	// bank update requests : get all bank update requests
	getSingleBankRequestDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/bank/get-details`, data);
	}

	// bank update requests : get ab bank history track
	getABBankHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/bank/get-track`, data);
	}

	// pan update requests : get ab pan history track
	getABPanHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/pan/get-track`, data);
	}

	// bank update requests : bank update request
	updatebankUpdateRequest(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/bank/update-request`, data);
	}

	// pan update requests : get all pan update requests
	getAllPANUpdateRequests() {
		return this.httpRequest('POST', `/kyc-admin/update-req/pan/get-all`);
	}

	// mobile update requests : get all mobile update requests
	getAllMobileUpdateRequests() {
		return this.httpRequest('POST', `/kyc-admin/update-req/mobile/get-all`);
	}

	// mobile update requests : get single mobile request details
	getSingleMobileRequestDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/mobile/get-details`, data);
	}

	// mobile update requests : update mobile request status
	updateMobileUpdateRequest(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/mobile/update-request`, data);
	}

	// mobile update requests : get ab mobile history tracks
	getABMobileHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/mobile/get-track`, data);
	}

	// pan update requests : get all pan update requests
	getSinglePANRequestDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/pan/get-details`, data);
	}

	// pan update requests :  pan update request
	updatePANUpdateRequest(data) {
		return this.httpRequest('POST', `/kyc-admin/update-req/pan/update-request`, data);
	}

	// pan update requests :  pan update request
	getBankRejectionReasons() {
		return this.httpRequest('GET', `/kyc-admin/generic/bank-rejection-reasons`);
	}

	// enable info : get ab details for re fill kyc
	getKycRefillABDetails(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/refill-kyc/get-ab-details`, request);
	}

	// enable info : enable re fill kyc
	enableRefillKyc(request) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/refill-kyc/enable-refill-check`, request);
	}

	//API call to add the batches
	addBatchUdaan(data) {
		return this.httpRequest('POST', `/udaan/add`, data);
	}

	//API call to update the batches
	updateBatchUdaan(data, id) {
		return this.httpRequest('PATCH', `/udaan/update/${id}`, data);
	}
	//API call to get the batch data
	getBatchUdaan(id) {
		return this.httpRequest('GET', `/udaan/get-batch/${id}`, null);
	}

	// Sehat Mitra Course Batch
	addSehatMitraCourseBatch(data) {
		return this.httpRequest('POST', `/sehat-mitra/course-batches/add`, data);
	}

	updateSehatMitraCourseBatch(data, id) {
		return this.httpRequest('PUT', `/sehat-mitra/course-batches/edit/${id}`, data);
	}

	getSehatMitraCourseBatch(id) {
		return this.httpRequest('GET', `/sehat-mitra/course-batches/${id}`, null);
	}

	getAllSehatMitraCourseBatchesData(page = 0, pageSize = 10, searchTerm = '') {
		let url = `/sehat-mitra/course-batches/all/${page}/${pageSize}`;
		if (searchTerm) {
			url += `?searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		return this.httpRequest('GET', url, null);
	}

	getSehatMitraCourseEligibleUsers(page = 0, pageSize = 10, searchTerm = '') {
		let url = `/sehat-mitra/course-registrations/eligible/${page}/${pageSize}`;
		if (searchTerm) {
			url += `?searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		return this.httpRequest('GET', url, null);
	}

	downloadSehatMitraCourseEligibleUsers(searchTerm = '') {
		let url = `/sehat-mitra/course-registrations/download-eligible`;
		if (searchTerm) {
			url += `?searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		return this.httpRequest('GET', url, null);
	}

	// API Call to fetch all batches
	getAllBatchesData(page = 0, pageSize = 10, searchTerm = '') {
		let url = `/udaan/all/${page}/${pageSize}`;
		if (searchTerm) {
			url += `?searchTerm=${encodeURIComponent(searchTerm)}`;
		}

		return this.httpRequest('GET', url);
	}
	// stop AB ID : Get AB Details
	getAbDetailsForABIDStop(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-id-stop/get-details`, data);
	}

	getAbDetailsForABIDUnStop(data) {
		return this.httpRequest('POST', `/kyc-super-admin/ab-unstop/get`, data);
	}

	// associate buyer : unstop AB ID
	unstopABID(data) {
		return this.httpRequest('POST', `/kyc-super-admin/ab-unstop/update`, data);
	}

	// ab reset pswrd : Get AB Details
	getAbDetailsForABResetPswrd(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/reset-pass/get-details`, data);
	}

	// mobile declaration : Get AB Details
	getAbDetailsForMobileDeclarartion(data) {
		return this.httpRequest('POST', `/kyc-admin/declaration/mobile/get-ab`, data);
	}

	// fetch pincode dta
	getkycPincodeDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/generic/get-pincode-data`, data);
	}

	// info update : Get AB Details
	getAbDetailsForInfoUpdate(data) {
		return this.httpRequest('POST', `/kyc-admin/declaration/info-update/get-ab`, data);
	}

	// info update : update ab details api
	updateABInfoDetails(data) {
		return this.httpRequest('PUT', `/kyc-admin/declaration/info-update/update-details`, data);
	}

	// Gst update : update gst details api
	updateABGstDetail(data, multiPart = true) {
		const distNo = data instanceof FormData ? data.get('dist_no') : data?.dist_no;
		return this.httpRequest('PUT', `/kyc-super-admin/gst-no/update-details?dist_no=${distNo}`, data, {multiPart});
	}

	//  manage executive : create executive
	createExecutive(data) {
		return this.httpRequest('POST', `/executives/create-new-executive`, data);
	}

	// manage executive : API To Make Get Request for Common API
	getExecutiveListForManageExecutives(apiUrl, payload) {
		return this.httpRequest('POST', `${apiUrl}`, payload);
	}

	// manage employees : API To Make Get Request for Common API
	getEmployeeListForManageEmployees(apiUrl, payload) {
		return this.httpRequest('POST', `${apiUrl}`, payload);
	}

	// registered buyer list : API To Make Get Request
	getRegisteredBuyerForMiscellaneous(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/miscellaneous/registered-buyer/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// normal buyer list : API To Make Get Request
	getNormalBuyerForMiscellaneous(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/miscellaneous/normal-buyer/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// Inactive registered buyer list : API To Make Get Request
	getInactiveRegisteredBuyer(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/miscellaneous/inactive-registered-buyer/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// Inactive registered buyer full export API
	exportInactiveRegisteredBuyer(payload) {
		return this.httpRequest('POST', '/kyc-admin/miscellaneous/inactive-registered-buyer/export', payload);
	}

	getAbSponsorAllowMisuseData(payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/miscellaneous/ab-sponsor-allow-misuse/get-sponsor-allow-misuse-data`,
			payload
		);
	}

	// normal buyer list : API To Make Get Request
	getAllDuplicateKeysForMiscellaneous() {
		return this.httpRequest('GET', `/kyc-admin/miscellaneous/duplicate-records/get`);
	}

	// normal buyer list : API To Make Get Request
	getAllDuplicateListForMiscellaneous(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/duplicate-records/get-all-list`, data);
	}

	// manage executive : get single executive data
	getSingleExecutiveData(id) {
		return this.httpRequest('GET', `/executives/get-single-executive/${id}`);
	}
	// manage executive : update single executive data
	updateSingleExecutiveData(data, id) {
		return this.httpRequest('PUT', `/executives/update-executive/${id}`, data);
	}

	// manage executive : delete executive(s)
	deleteExecutive(data) {
		return this.httpRequest('POST', `/executives/delete-multiple-executives`, data);
	}

	// assign kyc lead : get total number of kyc leads
	getNumberofKYCLeads(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/assign-kyc/get-kyc-leads`, data);
	}

	// assign kyc lead : get all execuitives list for assigning  kyc leads
	getExecutivesList() {
		return this.httpRequest('GET', `/executives/get-executives-lists`);
	}

	// assign kyc lead : get total number of kyc leads
	assignKycLeads(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/assign-kyc/assign-leads`, data);
	}
	// executive feedback report : Get User wise details
	getExecutivesForFeedbacks(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/executive-feed/get-details`, data);
	}

	// executive feedback report : Get User wise details
	getKycSummaryForFeedbacks() {
		return this.httpRequest('GET', `/kyc-admin/reports/executive-feed/kyc-summary`);
	}

	// executive feedback report : Get Approved Rejected kycs by user
	getApprovedRejectedKYCs(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/executive-feed/report`, data);
	}

	// executive feedback report : Get the AB Details for the Head Executive
	getABDetailsForHeadExecutive(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/executive-feed/ab-details`, data);
	}

	// executive feedback report : Update the final status for the KYC by Head Executive
	updateFinalKYCStatusByHeadExecutive(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/executive-feed/update-kyc-status`, data);
	}

	getAllBrandsList() {
		return this.httpRequest('GET', `/brands/brandList/all`);
	}

	// Reports: get self PV report - fetch data
	getSelfPVReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/self-pv-report`, data);
	}

	// API call to get Diamond Club
	getDiamondClubData(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/diamond-club-purchase`, data);
	}

	// Generic: get all brands for KYC
	KYC_getAllBrandList() {
		return this.httpRequest('GET', `/kyc-admin/generic/all-brands`);
	}

	// miscellanous : get died ab details
	getDiedABDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-extra/death-case/get-old-details`, data);
	}

	// miscellanous : get new ab details
	getNewABDetailsForDeathCase(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-extra/death-case/get-new-details`, data);
	}

	// API Call to fetch all Registered Users
	getRegisteredUsersUdaan(page = 1, pageSize = 10, searchTerm = '', filterTerm, batchType) {
		let url = `/udaan/all-registered-udaan-users/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to fetch all Registered Users and download
	downloadRegisteredUsers(searchTerm = '', filterTerm, batchType) {
		let url = `/udaan/download-registered-users?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to fetch all Grievances
	getGrievances(page = 1, pageSize = 10, searchTerm = '', filterTerm) {
		let url = `/grievance/all/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to download all Grievances
	downloadGrievances(searchTerm = '', filterTerm) {
		let url = `/grievance/download?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to update Grievance status and comments
	updateGrievance(data) {
		const {id, ...payload} = data;
		return this.httpRequest('PATCH', `/grievance/update/${id}`, payload);
	}

	// API Call to fetch all Registered Users for ulp quick
	getRegisteredUsersUlpQuick(page = 1, pageSize = 10, searchTerm = '', filterTerm, batchType) {
		let url = `/ulp-quick/all-registered-users/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to fetch all Registered Users and download for ulp quick
	downloadRegisteredUsersUlpQuick(searchTerm = '', filterTerm, batchType, status) {
		let url = `/ulp-quick/download-registered-users?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		if (status) {
			url += `&status=${encodeURIComponent(status)}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to approve/reject ulp quick registration
	updateUlpQuickRegistrationApproval(data) {
		return this.httpRequest('POST', `/ulp-quick/registration-approval`, data);
	}

	getRegisteredUsersSwasthyaShivir(page = 1, pageSize = 10, searchTerm = '', filterTerm, sortOrder = 'desc') {
		let url = `/swasthya-shivir/all-registered-users/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (sortOrder) {
			url += `&sortOrder=${encodeURIComponent(sortOrder)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	downloadRegisteredUsersSwasthyaShivir(searchTerm = '', filterTerm, sortOrder = 'desc') {
		let url = `/swasthya-shivir/download-registered-users?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (sortOrder) {
			url += `&sortOrder=${encodeURIComponent(sortOrder)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	updateSwasthyaShivirRegistrationApproval(data) {
		return this.httpRequest('POST', `/swasthya-shivir/registration-approval`, data);
	}

	// API Call to fetch ULP Quick Retention Report
	getUlpQuickRetentionReport({page = 1, pageSize = 10, searchTerm = '', filterTerm, isDownload = false} = {}) {
		const params = new URLSearchParams();

		if (searchTerm) {
			params.set('searchTerm', searchTerm);
		}
		if (filterTerm && Object.keys(filterTerm).length > 0) {
			params.set('filterTerm', JSON.stringify(filterTerm));
		}
		if (isDownload) {
			params.set('is_download', 'true');
		}

		const queryString = params.toString();
		return this.httpRequest(
			'GET',
			`/ulp-quick-retention-report/${page}/${pageSize}${queryString ? `?${queryString}` : ''}`
		);
	}
	// API Call to fetch all Eligible Users and download
	downloadEligibleUsers(searchTerm = '', filterTerm, batchType) {
		let url = `/udaan/download-eligible-users?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to fetch all summary of Users and download
	downloadSummaryOfUsers(searchTerm = '', filterTerm, batchType) {
		let url = `/udaan/download-summary?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to fetch all Eligible Users
	getEligibleUsersUdaan(page = 1, pageSize = 10, searchTerm = '', filterTerm, batchType) {
		let url = `/udaan/all-eligible/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}
	// API Call to fetch all Registered Summary
	getAllSummary(page = 1, pageSize = 10, searchTerm = '', filterTerm, batchType) {
		let url = `/udaan/all-summary/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		if (batchType) {
			url += `&batchType=${encodeURIComponent(batchType)}`;
		}
		return this.httpRequest('GET', url);
	}

	// Check Udaan eligible
	getEligibleUser(data) {
		return this.httpRequest('POST', `/udaan//eligible-distno`, data);
	}
	// reports: Non Purchasing AB Report
	getNonPurchasingABReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/terminate-list`, data);
	}

	// reports: Stop Termination Report
	getStopTerminationReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/stop-termination-report/get`, data);
	}

	// miscellanous :  update deat case
	updateDeathCase(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-extra/death-case/update-details`, data);
	}

	// Get All Bank List for Branches
	getAllBanksList() {
		return this.httpRequest('GET', `/branches/get-all-banks`);
	}

	// Search AB Details By State - Get All States
	getStatesForSearchABByName(data) {
		return this.httpRequest('GET', `/kyc-admin/generic/get-state`, data);
	}

	// Search AB Details By State - Get All Districts
	getDistrictForSearchABByName(data) {
		return this.httpRequest('GET', `/kyc-admin/generic/get-district?state_code=${data}`);
	}

	// Search AB Details By State - Get All Associate Buyers by state and district
	searchABByStateDistrictName(page, pageSize, data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/ab-by-name/${page}/${pageSize}`, data);
	}

	// Reports : amount wise ab count report
	getABCountByAmountWiseReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/amount-wise-ab-count`, data);
	}

	// Reports : Pin Achiever Report
	getPinAchieverReport() {
		return this.httpRequest('POST', `/kyc-admin/reports/pin-achiever-report`);
	}

	// Reports : Pin Dashboard Report
	getPinDashboardReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/pin-dashboard`, data);
	}

	// Search AB Details : get ab details by reference number
	fetchAbDetailsByReferenceNo(data) {
		return this.httpRequest('POST', `/kyc-admin/search-info/reference`, data);
	}

	// Generic => Get the available years
	getAvailableYearsforKYC() {
		return this.httpRequest('GET', `/kyc-admin/generic/available-years`);
	}

	// Associate Buyer => Get the available months
	getAvailableMonthsforKYC() {
		return this.httpRequest('GET', `/kyc-admin/generic/available-months`);
	}

	// Ab Name Update : get ab details
	getABDetailsForNameUpdate(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/name-update/get`, data);
	}

	// Ab Name Update : update ab details
	updateABName(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/name-update/update`, data);
	}

	// Associate Buyer => Get the AB Purchase Download Report
	getLastSixMonthsPurchaseReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/ab-last-6-months/get-list`, data);
	}

	// Associate Buyer => Get the AB Purchase Download Report
	getLastSixMonthsPurchaseReportOld(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/ab-last-6-months/get-uploaded-list`, data);
	}

	// ab bank accnt update : get ab details
	getAbDetailsForBankDetailsUpdate(data) {
		return this.httpRequest('POST', `/kyc-admin/doc-update/ab-bank-update/get-details`, data);
	}

	//ab bank accnt update : API call to get banks list
	getBanksList() {
		return this.httpRequest('GET', `/kyc-admin/generic/all-banks`);
	}

	// ab bank accnt update : : API call to get bank branches list
	getBankBranchesList(data) {
		return this.httpRequest('POST', `/kyc-admin/generic/all-branches`, data);
	}

	// ab bank accnt update : get states list for bank update
	getStatesListForBankUpdate() {
		return this.httpRequest('GET', `/kyc-admin/generic/get-state`);
	}

	// ab bank accnt update : update ban accnt details api
	updateABBankAccntDetails(data, multiPart = true) {
		const distNo = data instanceof FormData ? data.get('dist_no') : data?.dist_no;
		return this.httpRequest(
			'POST',
			`/kyc-admin/doc-update/ab-bank-update/update-bank-details?dist_no=${distNo}`,
			data,
			{multiPart}
		);
	}

	// accounts: get generated business / commission status
	getGeneratedBusiness(data) {
		const {page, pageSize, searchTerm, year, month} = data || {};
		let queryParams = new URLSearchParams();

		if (page !== undefined && page !== null) queryParams.append('page', page);
		if (pageSize !== undefined && pageSize !== null) queryParams.append('pageSize', pageSize);
		if (searchTerm !== undefined && searchTerm !== null) queryParams.append('searchTerm', searchTerm);
		if (year !== undefined && year !== null) queryParams.append('year', year);
		if (month !== undefined && month !== null) queryParams.append('month', month);

		let url = `/accounts/commission-cycle/fetch-business${
			queryParams.toString() ? '?' + queryParams.toString() : ''
		}`;
		return this.httpRequest('GET', url);
	}

	// accounts: finalize monthly run and promote ledger
	finalizeCommissionCycle(data = {}) {
		return this.httpRequest('POST', `/accounts/commission-cycle/finalize-monthly-run`, data);
	}

	// accounts: fetch payout remarks for a distributor
	fetchCommissionCycleRemarks(data = {}) {
		return this.httpRequest('POST', `/accounts/commission-cycle/fetch-remarks`, data);
	}

	// accounts: generate business / commission cycle
	generateBusiness(data = {}) {
		return this.httpRequest('POST', `/accounts/commission-cycle/generate-business`, data);
	}

	// accounts: download business report
	async downloadBusiness(data = {}) {
		const {year, month} = data || {};
		let queryParams = new URLSearchParams();
		if (year !== undefined && year !== null) queryParams.append('year', year);
		if (month !== undefined && month !== null) queryParams.append('month', month);

		const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
		const path = `/accounts/commission-cycle/download-business${queryString}`;
		try {
			let token = localStorage.getItem('Authorization');
			return await fetch(`${this.basePath}${path}`, {
				method: 'GET',
				headers: {
					...{Authorization: `Bearer ${token}`},
				},
			});
		} catch (e) {
			return new Promise((_, reject) => reject);
		}
	}

	// accounts: get generated cash bonus status
	getGeneratedCashBonus(data) {
		const {page, pageSize, searchTerm, year, month} = data || {};
		let queryParams = new URLSearchParams();

		if (page !== undefined && page !== null) queryParams.append('page', page);
		if (pageSize !== undefined && pageSize !== null) queryParams.append('pageSize', pageSize);
		if (searchTerm !== undefined && searchTerm !== null) queryParams.append('searchTerm', searchTerm);
		if (year !== undefined && year !== null) queryParams.append('year', year);
		if (month !== undefined && month !== null) queryParams.append('month', month);

		let url = `/accounts/cash-bonus-cycle/fetch-business${
			queryParams.toString() ? '?' + queryParams.toString() : ''
		}`;
		return this.httpRequest('GET', url);
	}

	// accounts: finalize cash bonus monthly run and promote ledger
	finalizeCashBonusCycle(data = {}) {
		return this.httpRequest('POST', `/accounts/cash-bonus-cycle/finalize-monthly-run`, data);
	}

	// accounts: rollback cash bonus cycle
	rollbackCashBonusCycle(data = {}) {
		return this.httpRequest('POST', `/accounts/cash-bonus-cycle/rollback`, data);
	}

	// accounts: fetch payout remarks for a distributor in cash bonus
	fetchCashBonusCycleRemarks(data = {}) {
		return this.httpRequest('POST', `/accounts/cash-bonus-cycle/fetch-remarks`, data);
	}

	// accounts: generate cash bonus cycle
	generateCashBonusCycle(data = {}) {
		return this.httpRequest('POST', `/accounts/cash-bonus-cycle/generate-business`, data);
	}

	// accounts: download cash bonus report
	async downloadCashBonusBusiness(data = {}) {
		const {year, month} = data || {};
		let queryParams = new URLSearchParams();
		if (year !== undefined && year !== null) queryParams.append('year', year);
		if (month !== undefined && month !== null) queryParams.append('month', month);

		const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
		const path = `/accounts/cash-bonus-cycle/download-business${queryString}`;
		try {
			let token = localStorage.getItem('Authorization');
			return await fetch(`${this.basePath}${path}`, {
				method: 'GET',
				headers: {
					...{Authorization: `Bearer ${token}`},
				},
			});
		} catch (e) {
			return new Promise((_, reject) => reject);
		}
	}

	// KYC - Verification - Get all assigned kycs to the executive
	getAssignedKYCToExecutive(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/verification/get-exec-current-leads`, data);
	}

	// KYC - Verification - Get ab details for executive revirew
	getAbDetailsForExecutiveReview(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/verification/review-ab-details`, data);
	}

	// KYC - Verification - Get similar entities for executive review
	getSimilarEntitiesForExecutiveReview(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/verification/similar-entities`, data);
	}

	// KYC - Verification - Assign a new kyc lead to the executive
	assignNewKYCToExecutive() {
		return this.httpRequest('GET', `/kyc-admin/kyc-mod/verification/assign-new-kyc-lead`);
	}

	// KYC - Verification - Update the kyc status by executive
	updateKYCStatusByExecutive(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/verification/update-kyc-status`, data);
	}

	// AB Photo - Get AB Photo By Number
	getABPhotoByDistNumber(data) {
		return this.httpRequest('POST', `/kyc-admin/generic/get-ab-photo`, data);
	}

	// get Ecom users for permission
	getAllEcomUserForPermission(url) {
		return this.httpRequest('GET', `/ecom-user-permission/all` + url);
	}
	// get single Ecom users for permission
	getSingleEcomUserForPermission(data) {
		return this.httpRequest('GET', `/ecom-user-permission/` + data);
	}
	// update Ecom users for permission
	updateEcomUserPermission(id, data) {
		return this.httpRequest('PUT', `/ecom-user-permission/` + id, data);
	}

	// GET Ecom Permission
	getAllPermission() {
		return this.httpRequest('GET', `/ecom-user-permission/permission`);
	}

	// Remarks Master => get paginated remarks
	getRemarksList(page = 0, pageSize = 10, params = {}) {
		const queryParams = new URLSearchParams();
		if (params?.searchTerm) queryParams.append('searchTerm', params.searchTerm);
		if (params?.module_name) queryParams.append('module_name', params.module_name);

		const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
		return this.httpRequest('GET', `/remarks/all/${page}/${pageSize}${query}`);
	}

	// Remarks Master => get single remark details
	getRemarkById(id) {
		return this.httpRequest('GET', `/remarks/${id}`);
	}

	// Remarks Master => create new remark
	createRemark(data) {
		return this.httpRequest('POST', `/remarks`, data);
	}

	// Remarks Master => update a remark
	updateRemark(id, data) {
		return this.httpRequest('PUT', `/remarks/${id}`, data);
	}

	// Remarks Master => delete one or multiple remarks
	deleteRemarks(data) {
		return this.httpRequest('DELETE', `/remarks`, data);
	}

	// Remark Modules Master => get paginated module names
	getRemarkModulesList(page = 0, pageSize = 10, params = {}) {
		const queryParams = new URLSearchParams();
		if (params?.searchTerm) queryParams.append('searchTerm', params.searchTerm);
		const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
		return this.httpRequest('GET', `/remark-modules/all/${page}/${pageSize}${query}`);
	}

	// Remark Modules Master => dropdown options
	getRemarkModulesDropdown() {
		return this.httpRequest('GET', `/remark-modules/dropdown`);
	}

	// Remark Modules Master => get single module by id
	getRemarkModuleById(id) {
		return this.httpRequest('GET', `/remark-modules/${id}`);
	}

	// Remark Modules Master => create new module
	createRemarkModule(data) {
		return this.httpRequest('POST', `/remark-modules`, data);
	}

	// Remark Modules Master => update module
	updateRemarkModule(id, data) {
		return this.httpRequest('PUT', `/remark-modules/${id}`, data);
	}

	// Remark Modules Master => delete modules
	deleteRemarkModules(data) {
		return this.httpRequest('DELETE', `/remark-modules`, data);
	}

	// Grand Growth Award Leaders => search AB master details
	searchGrandGrowthAwardLeader(abId) {
		return this.httpRequest('GET', `/grand-growth-award/leaders/search/${abId}`);
	}

	// Grand Growth Award Leaders => add leader
	createGrandGrowthAwardLeader(data) {
		return this.httpRequest('POST', `/grand-growth-award/leaders`, data);
	}

	// Grand Growth Award Leaders => get paginated leaders
	getGrandGrowthAwardLeaders(page = 0, pageSize = 10, legType = null) {
		const query = legType ? `?leg_type=${encodeURIComponent(legType)}` : '';
		return this.httpRequest('GET', `/grand-growth-award/leaders/all/${page}/${pageSize}${query}`);
	}

	// Grand Growth Award Leaders => update leader (status and/or leg)
	updateGrandGrowthAwardLeader(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/leaders/${id}`, data);
	}

	// Grand Growth Award Reports => create report
	createGrandGrowthAwardReport(data) {
		return this.httpRequest('POST', `/grand-growth-award/reports`, data);
	}

	// Grand Growth Award Reports => get paginated reports
	getGrandGrowthAwardReports(page = 0, pageSize = 10) {
		return this.httpRequest('GET', `/grand-growth-award/reports/all/${page}/${pageSize}`);
	}

	// Grand Growth Award Reports => get single report
	getGrandGrowthAwardReportById(id) {
		return this.httpRequest('GET', `/grand-growth-award/reports/${id}`);
	}
	// Grand Growth Award Reports report dropdown
	getGrandGrowthAwardReportDropdown(id) {
		return this.httpRequest('GET', `/grand-growth-award/assign/report/dropdown`);
	}
	// Grand Growth Award Reports leader dropdwon
	getGrandGrowthAwardLeaderDropdown(id) {
		return this.httpRequest('GET', `/grand-growth-award/assign/leader/dropdown`);
	}
	// Create Grand Growth Award Report Assign
	createGrandGrowthReportAssign(data) {
		return this.httpRequest('POST', `/grand-growth-award/assign`, data);
	}
	// Update Grand Growth Award Report Assign
	grandGrowthReportAssignUpdate(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/assign/${id}`, data);
	}
	// GEt Grand Growth Award Report Assign
	getGrandGrowthAwardReportAssigns(page = 0, pageSize = 10, legType = null) {
		const query = legType ? `?leg_type=${encodeURIComponent(legType)}` : '';
		return this.httpRequest('GET', `/grand-growth-award/assign/all/${page}/${pageSize}${query}`);
	}
	// GEt Grand Growth Award Report Assign By Id
	getGrandGrowthAwardReportAssignsById(id) {
		return this.httpRequest('GET', `/grand-growth-award/assign/${id}`);
	}

	// Grand Growth Award Reports => update report Assign
	updateGrandGrowthAwardReportById(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/assign/${id}`, data);
	}

	// Grand Growth Award Reports => update report
	updateGrandGrowthAwardReport(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/reports/${id}`, data);
	}

	// Grand Growth Award Reports => delete report
	deleteGrandGrowthAwardReport(id) {
		return this.httpRequest('DELETE', `/grand-growth-award/reports/${id}`);
	}

	// Grand Growth Award Reports => active reports dropdown
	getGrandGrowthAwardReportsDropdown() {
		return this.httpRequest('GET', `/grand-growth-award/reports/dropdown`);
	}

	// ==========================================
	// Grand Growth Award Eligibility List APIs
	// ==========================================

	// Grand Growth Award Eligibility => get paginated eligibility list
	getGrandGrowthAwardEligibilityList(page = 0, pageSize = 10, params = {}) {
		const queryParams = new URLSearchParams();
		if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);
		if (params.dateFilter) queryParams.append('dateFilter', params.dateFilter);
		if (params.sortBy) queryParams.append('sortBy', params.sortBy);
		if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
		const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
		return this.httpRequest('GET', `/grand-growth-award/eligibility/all/${page}/${pageSize}${queryString}`);
	}

	// Grand Growth Award Eligibility => get single eligibility record by ID
	getGrandGrowthAwardEligibilityById(id) {
		return this.httpRequest('GET', `/grand-growth-award/eligibility/${id}`);
	}

	// Grand Growth Award Eligibility => add single record
	addGrandGrowthAwardEligibility(data) {
		return this.httpRequest('POST', `/grand-growth-award/eligibility`, data);
	}

	// Grand Growth Award Eligibility => update record
	updateGrandGrowthAwardEligibility(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/eligibility/${id}`, data);
	}

	// Grand Growth Award Eligibility => delete record
	deleteGrandGrowthAwardEligibility(id) {
		return this.httpRequest('DELETE', `/grand-growth-award/eligibility/${id}`);
	}

	// Grand Growth Award Eligibility => bulk upload excel file
	uploadGrandGrowthAwardEligibilityExcel(data) {
		return this.httpRequest('POST', `/grand-growth-award/eligibility/upload-excel`, data, {
			multiPart: true,
		});
	}

	// Grand Growth Award Eligibility => download sample excel template
	downloadGrandGrowthAwardEligibilityTemplate() {
		return this.httpRequestBlob('GET', `/grand-growth-award/eligibility/template`, null);
	}

	// Grand Growth Award Eligibility => export list to excel
	exportGrandGrowthAwardEligibilityExcel(params = {}) {
		const queryParams = new URLSearchParams();
		if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);
		if (params.dateFilter) queryParams.append('dateFilter', params.dateFilter);
		const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
		return this.httpRequestBlob('GET', `/grand-growth-award/eligibility/export${queryString}`, null);
	}

	// ==========================================
	// Grand Growth Award Final Export Report APIs
	// ==========================================

	// Final Export => get paginated report list
	getGrandGrowthAwardFinalExportList(page = 0, pageSize = 10, params = {}) {
		const queryParams = new URLSearchParams();
		queryParams.append('page', page);
		queryParams.append('pageSize', pageSize);
		if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);
		if (params.dateFilter) queryParams.append('dateFilter', params.dateFilter);
		return this.httpRequest('GET', `/grand-growth-award/final-export/list?${queryParams.toString()}`);
	}

	// Final Export => export report to excel
	exportGrandGrowthAwardFinalExportExcel(params = {}) {
		const queryParams = new URLSearchParams();
		if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);
		if (params.dateFilter) queryParams.append('dateFilter', params.dateFilter);
		const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
		return this.httpRequestBlob('GET', `/grand-growth-award/final-export/excel${queryString}`, null);
	}

	// ==========================================
	// Grand Growth Award Level 1 / Level 2 Check-in APIs
	// ==========================================

	// Level 1 Check-in => search by AB ID / Token ID
	searchGrandGrowthAwardLevel1(abId) {
		return this.httpRequest('GET', `/grand-growth-award/level1-check/${abId}`);
	}

	// Level 1 Check-in => submit decision
	submitGrandGrowthAwardLevel1(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/level1-check/${id}`, data);
	}

	// Level 2 Check-in => search by AB ID / Token Number
	searchGrandGrowthAwardLevel2(abId) {
		return this.httpRequest('GET', `/grand-growth-award/level2-check/${abId}`);
	}

	// Level 2 Check-in => submit reward issuance
	submitGrandGrowthAwardLevel2(id, data) {
		return this.httpRequest('PUT', `/grand-growth-award/level2-check/${id}`, data);
	}

	// ADMIN REPORTS => Death Case Report
	getDeathCaseReport() {
		return this.httpRequest('POST', `/kyc-admin/reports/death-case`);
	}

	// ADMIN REPORTS => Stopped AB Report
	getStoppedABReport() {
		return this.httpRequest('POST', `/kyc-admin/reports/stop-ab`);
	}

	// ADMIN REPORTS => Terminate AB Report
	getTerminateABReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/terminate-ab`, data);
	}

	pvBulkUpload(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/utility/bulk-upload/${randomId}`, data, {multiPart});
	}

	bulkUploadUpdatePrice(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/update-price/bulk-upload/${randomId}`, data, {multiPart});
	}

	// Get All Depots
	getAllDepots({page = 0, pageSize = 10, searchTerm}) {
		let url = `/public-depots/get-all/${page}/${pageSize}`;

		// Append the searchTerm if provided
		if (searchTerm) {
			url += `?searchTerm=${searchTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// Get Single Depot
	getSingleDepot(id) {
		return this.httpRequest('GET', `/public-depots/get-by-id/${id}`);
	}

	// Add New Depot
	addNewDepot(data) {
		return this.httpRequest('POST', `/public-depots/add-depot`, data);
	}

	// Update Depot
	updateDepot(id, data) {
		return this.httpRequest('PUT', `/public-depots/update-depot/${id}`, data);
	}

	// Get All Country States
	getAllStatesForDepot() {
		return this.httpRequest('GET', `/generic/get-all-country-states-for-depot`);
	}

	// Profile Menu Management - Get All Ecom Profile Menu
	getAllEcomProfileMenu() {
		return this.httpRequest('GET', `/ecom-modules/get-all-modules`);
	}

	// Profile Menu Management - Get Single Ecom Profile Menu
	getSingleEcomProfileMenu(id) {
		return this.httpRequest('GET', `/ecom-modules/get-module-by-id/${id}`);
	}

	// Profile Menu Management - Add New Ecom Profile Menu
	addNewEcomProfileMenu(data) {
		return this.httpRequest('POST', `/ecom-modules/add-module`, data, {multiPart: true});
	}

	// Profile Menu Management - Update Ecom Profile Menu
	updateEcomProfileMenu(id, data) {
		return this.httpRequest('PUT', `/ecom-modules/update-module/${id}`, data, {multiPart: true});
	}
	// API call to get state list
	getStatesGeneric() {
		return this.httpRequest('GET', `/generic/state-list`);
	}
	//API call to get all the parent categories
	getAllParentCategories() {
		return this.httpRequest('GET', '/categories/get-all/parent-categories');
	}

	/**
	 * Create AB Scheduled Message API Call
	 * @param {*} data
	 * @returns
	 */
	createAbScheduledMessageData(data) {
		return this.httpRequest('POST', `/ab-schedule-messages`, data, {multiPart: true});
	}

	/**
	 * Update AB Scheduled Message API Call
	 * @param {*} data
	 * @param {*} id
	 * @returns
	 */
	updateAbScheduledMessageData(data, id) {
		return this.httpRequest('PUT', `/ab-schedule-messages/${id}`, data, {multiPart: true});
	}

	/**
	 * Delete AB Scheduled Messages API Call
	 * @param {*} data
	 * @returns
	 */
	deleteAbScheduledMessages(data) {
		return this.httpRequest('DELETE', `/ab-schedule-messages`, data);
	}

	/**
	 * Get Single AB Scheduled Message API Call
	 * @param {*} id
	 * @returns
	 */
	getSingleAbScheduledMessageData(id) {
		return this.httpRequest('GET', `/ab-schedule-messages/${id}`);
	}

	/**
	 * Get brand related categories
	 * @param {*} brand_id
	 * @returns
	 */
	getBrandRelatedCategories(brand_id) {
		return this.httpRequest('GET', `/products/categories/0/1000?brand_id=${brand_id}`);
	}

	// API Call to fetch pinconde listing
	getAllPincodeListing(apiUrl) {
		return this.httpRequest('GET', `/pincodelisting/pincode/list/all/${apiUrl}`);
	}
	// API Call to fetch pinconde listing
	getAllStateCodeList() {
		return this.httpRequest('GET', `/pincodelisting/get-all/state`);
	}
	//  get district list by state code
	getDIstrictListByStateCode(data) {
		return this.httpRequest('POST', `/pincodelisting/get-district-list`, data);
	}
	// Add new pin code
	addNewPincodeApi(data) {
		return this.httpRequest('POST', `/pincodelisting/add-new-pincode`, data);
	}

	// Call Center Reports - Plantations: get plantations list
	getPlantationsList(page, pageSize, startDate, endDate) {
		const start = startDate ? `&startDate=${startDate}` : '';
		const end = endDate ? `&endDate=${endDate}` : '';
		return this.httpRequest(
			'GET',
			`/call-center-reports/plantations/list/${page}/${pageSize}?${start}${end}`,
			null
		);
	}

	// Call Center Reports - Blood Donors: get blood donors list
	getBloodDonorsList(page, pageSize, startDate, endDate) {
		const start = startDate ? `&startDate=${startDate}` : '';
		const end = endDate ? `&endDate=${endDate}` : '';
		return this.httpRequest(
			'GET',
			`/call-center-reports/blood-donors/list/${page}/${pageSize}?${start}${end}`,
			null
		);
	}

	getPincodeDetailsByID(id) {
		return this.httpRequest('GET', `/pincodelisting/get/single/${id}`, null);
	}

	// Add new pin code
	editPincodeDetailsApi(data) {
		return this.httpRequest('POST', `/pincodelisting/edit-pincode-details`, data);
	}

	// API CALL to fetch downline info
	getDistAndDownlineDetails(data) {
		return this.httpRequest('GET', `/purchaser-in-your-group/get-dist-and-downline-info?dist_no=` + data);
	}

	// API call to get Last Six months Joinings
	getLastSixMonthsJoining(url) {
		return this.httpRequest('GET', `/purchaser-in-your-group/group-purchase/last-six-month` + url);
	}

	// get upline achieviers for group purchase page
	getGroupPvULAchiever({searchTerm}) {
		return this.httpRequest(
			'GET',
			`/purchaser-in-your-group/group-purchase/up-level-data` + (searchTerm ? `?distno=${searchTerm}` : ``)
		);
	}

	// get group purchase table data
	getGroupPurchaseTableData({type, url}) {
		return this.httpRequest('GET', `/purchaser-in-your-group/group-purchase/table-reports/${type}` + url);
	}

	// API Call to get brand dropdown
	getBrandDropDown() {
		return this.httpRequest('GET', `/purchaser-in-your-group/all-brands-dropdown`, null);
	}

	// API call to get Last Six months Joinings
	getLastSixMonthsGroupPurchase(url) {
		return this.httpRequest('GET', `/purchaser-in-your-group/group-purchase/six-months-group-purchase` + url);
	}

	getAbInfo(data) {
		return this.httpRequest('POST', `/generic/get-ab-info`, data);
	}

	// Call Center Reports - Get Users List
	getCallCenterUserDetailsData(page = 0, pageSize = 10, searchTerm = '') {
		return this.httpRequest(
			'GET',
			`/call-center-reports/user-details/users-list/${page}/${pageSize}?searchTerm=${searchTerm}`
		);
	}

	// Call Center Reports - Get User Details by ID
	getCallCenterUserDetail(userId) {
		return this.httpRequest('GET', `/call-center-reports/user-details/${userId}`);
	}

	// Admin wallet details by ab no
	getWalletDetailsSearch(data) {
		return this.httpRequest('POST', `/admin/reports/miscellaneous/consistency-dashboard/wallet-detail`, data);
	}

	// Ab wallet bill details
	getWalletBillDetailsByAbNo(data) {
		return this.httpRequest(
			'POST',
			`/admin/reports/miscellaneous/consistency-dashboard/get-wallet-bill-details`,
			data
		);
	}

	// Get ab name
	loginAb(request) {
		return this.httpRequest('POST', `/generic/mdm/login-user`, request);
	}

	// Download purchaser in your group report route
	getDownloadReportPurchaserInYourGroup(url) {
		return this.httpRequest('GET', `/purchaser-in-your-group/reports/${url}`);
	}

	// Download purchaser in your group report progress job status check
	getDownloadReportPurchaserInYourGroupStatus(jobId) {
		return this.httpRequest('GET', `/purchaser-in-your-group/reports/export/status/${jobId}`);
	}

	// Download purchaser in your group report final download
	getDownloadReportPurchaserInYourGroupFinalDownload(jobId) {
		return this.httpRequestBlob('GET', `/purchaser-in-your-group/reports/export/download/${jobId}`);
	}

	// Download purchaser in your group report delete in case of changing drop down values to reset the download
	getDownloadReportPurchaserInYourGroupDelete(jobId) {
		return this.httpRequest('DELETE', `/purchaser-in-your-group/reports/export/delete/${jobId}`);
	}

	// mobile history list : API To Make Get Request
	getMobileHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/mobile-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// name history list : API To Make Get Request
	getNameHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/name-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// email history list : API To Make Get Request
	getEmailHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/email-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// pan history list : API To Make Get Request
	getPanHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/pan-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// bank history list : API To Make Get Request
	getBankHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/bank-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// Address history list : API To Make Get Request
	getAddressHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/address-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// AB Image history list : API To Make Get Request
	getImageHistoryForKyc(payload) {
		return this.httpRequest('POST', `/kyc-admin/kyc-history/image-history/get-list`, payload);
	}

	// Report API methods
	/**
	 * Get brands for reports
	 */
	getReportBrands() {
		return this.httpRequest('GET', `/generic/all-brands`);
	}

	/**
	 * Get Display Wall Report data
	 */
	getDisplayWallReport(queryString) {
		return this.httpRequest('GET', `/report/display-wall-report${queryString}`, null);
	}

	/**
	 * Get PUC Report data
	 */
	getPUCReport(queryString) {
		return this.httpRequest('GET', `/report/puc-report${queryString}`, null);
	}

	/**
	 * Get PUC Report summary dashboard data
	 */
	getPucReportSummary(queryUrl) {
		return this.httpRequest('GET', `/report/puc-report/summary` + queryUrl);
	}

	/**
	 * Get distributor and downline info
	 */
	getDistAndDownlineInfo(queryString) {
		return this.httpRequest('GET', `/generic/get-dist-and-downline-info${queryString}`, null);
	}

	/**
	 * Get upline achiever data
	 */
	getReportULAchiever({searchTerm}) {
		return this.httpRequest('GET', `/generic/up-level-data${searchTerm ? `?distno=${searchTerm}` : ''}`, null);
	}

	// API CALL to fetch Dist info
	getDistDetails(data) {
		return this.httpRequest('GET', `/your-group/get-distributor-info?dist_no=` + data);
	}

	// API CALL to fetch downline info
	getDownlineDetails(data) {
		return this.httpRequest('GET', `/your-group/get-distributor-downline?dist_no=` + data);
	}
	// API CALL to fetch category dropdown
	getCategoryDropdown() {
		return this.httpRequest('GET', `/product-purchase/get-category-dropdown`);
	}

	getFinalYear() {
		return this.httpRequest('GET', `/product-purchase/get-financial-year`);
	}

	// API call to get product purchase data
	getProductPurchase({buyerNumber, productList, year}) {
		return this.httpRequest(
			'GET',
			`/product-purchase/get-product-purchase-data?buyer_no=` +
				(buyerNumber ? buyerNumber : ``) +
				`&product=` +
				(productList ? productList : ``) +
				`&year=` +
				(year ? year : ``)
		);
	}

	// API call to get date wise pv
	getAllDateWisePv({pageSize, searchTerm, day, month, year}) {
		return this.httpRequest(
			'GET',
			`/last-month-pv-date-wise/last-month-date-pv/all/${pageSize}` +
				(searchTerm ? `?distno=${searchTerm}` : ``) +
				(day ? `&day=${day}` : ``) +
				(month ? `&month=${month}` : ``) +
				(year ? `&year=${year}` : ``)
		);
	}

	// API call to get product list for PV Calculator
	getProductListForPVCalculator(searchTerm, page = 0, pageSize = 20) {
		return this.httpRequest(
			'GET',
			`/generic/get-product-dropdown/${page}/${pageSize}?searchTerm=` + (searchTerm ? searchTerm : ``)
		);
	}

	// API call to get tax invoice data
	getTaxInvoiceData(url) {
		return this.httpRequest('GET', `/report/tax-invoice` + url);
	}

	getGstInvoiceData(data) {
		return this.httpRequest('POST', `/report/tax-invoice`, data);
	}

	//Enable Info => Enable Bank List
	getEnabledBankList(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank-account/get-enabled-list`, data);
	}

	//Disable Info => Disable Bank List
	disableABBankEnableAccount(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank-account/disable-bank-enable`, data);
	}

	// Associate Buyer => Enable Bulk Bank Enabled
	enabledBulkUploadedBankList(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank-account/enabled-bulk-list`, data);
	}

	// API call to get product purchase monthly data
	getProductPurchaseMonthly({buyerNumber, year}) {
		return this.httpRequest(
			'GET',
			`/report/product-purchase-monthly-data?buyer_no=` +
				(buyerNumber ? buyerNumber : ``) +
				`&year=` +
				(year ? year : ``)
		);
	}

	//ab wallet update : API call to get wallet list
	getWalletList() {
		return this.httpRequest('GET', `/kyc-admin/generic/get-all-wallet`);
	}

	// ab wallet update : API call to get wallet remaining balance
	getWalletRemainingBalance() {
		return this.httpRequest('GET', `/wallets/remaining-balance`);
	}

	/**
	 * Upload mapped bulk file API Call
	 * @param {*} data
	 * @param {*} multiPart
	 * @returns
	 */

	uploadMappedBulkUploadFileV2(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/walletmaps/bulk-upload-v2/${randomId}`, data, {multiPart});
	}
	// Product Category Report API
	async getProductCategoryReport({
		page = 1,
		pageSize = 10,
		startDate,
		endDate,
		orderStatus,
		orderType,
		isExport,
	} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(orderStatus !== null && orderStatus !== undefined ? {orderStatus} : {}),
			...(isExport ? {isExport: 'true'} : {}),
		});

		// Handle orderType array parameter
		if (orderType && orderType.length > 0) {
			orderType.forEach(item => {
				params.append('orderType[]', item);
			});
		}
		if (isExport) {
			return this.httpRequestBlob('GET', `/product-category-report?${params.toString()}`);
		}

		return this.httpRequest('GET', `/product-category-report?${params.toString()}`);
	}

	// get labels for bulk sms
	getBulkSmsLabel() {
		return this.getRequest('/kyc-super-admin/bulk-sms/sms-list');
	}

	// send bulk sms
	sendBulkSms(data) {
		return this.httpRequest('POST', '/kyc-super-admin/bulk-sms/send', data);
	}

	// Cart Products Report API
	async getCartProductsReport({page = 1, pageSize = 10, startDate, endDate, isExport} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(isExport ? {isExport: 'true'} : {}),
		});
		if (isExport) {
			return this.httpRequestBlob('GET', `/cart-products-report?${params.toString()}`);
		}

		return this.httpRequest('GET', `/cart-products-report?${params.toString()}`);
	}

	// AB Growth Report API
	async getABGrowthReport({distno, type, financial_year} = {}) {
		const params = new URLSearchParams({
			...(distno ? {distno} : {}),
			...(type ? {type} : {}),
			...(financial_year ? {financial_year} : {}),
		});

		return this.httpRequest('GET', `/ab-growth-report?${params.toString()}`);
	}

	// ULP Program Report APIs
	async getUlpRegistrationReport(data) {
		return this.httpRequest('POST', `/ulp-program-report/ulp-registration`, data);
	}

	async getEventRegistrationReport(data) {
		return this.httpRequest('POST', `/ulp-program-report/event-registration`, data);
	}

	async getProspectJoiningPurchaseReport(data) {
		return this.httpRequest('POST', `/ulp-program-report/prospect-joining-purchase`, data);
	}

	async getAvailableUlpDates(params) {
		const queryParams = new URLSearchParams();
		if (params.zone) queryParams.append('zone', params.zone);
		if (params.state) queryParams.append('state', params.state);
		if (params.district) queryParams.append('district', params.district);
		if (params.month) queryParams.append('month', params.month);
		if (params.financialYear) queryParams.append('financialYear', params.financialYear);

		return this.httpRequest('GET', `/ulp-program-report/available-ulp-dates?${queryParams.toString()}`);
	}

	// Zonal Program Report APIs
	async getZonalRegistrationReport(data) {
		return this.httpRequest('POST', `/zonal-program-report/zonal-registration`, data);
	}

	async getZonalEventRegistrationReport(data) {
		return this.httpRequest('POST', `/zonal-program-report/event-registration`, data);
	}

	async getZonalProspectJoiningPurchaseReport(data) {
		return this.httpRequest('POST', `/zonal-program-report/prospect-joining-purchase`, data);
	}

	async getAvailableZonalDates(params) {
		const queryParams = new URLSearchParams();
		if (params.zone) queryParams.append('zone', params.zone);
		if (params.state) queryParams.append('state', params.state);
		if (params.district) queryParams.append('district', params.district);
		if (params.month) queryParams.append('month', params.month);
		if (params.financialYear) queryParams.append('financialYear', params.financialYear);

		return this.httpRequest('GET', `/zonal-program-report/available-zonal-dates?${queryParams.toString()}`);
	}

	// Report View Logs API
	async getReportViewLogs({page = 1, pageSize = 20, startDate, endDate, distno, reportId} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(distno ? {distno} : {}),
			...(reportId ? {reportId} : {}),
		});

		return this.httpRequest('GET', `/report-view-logs?${params.toString()}`);
	}

	// User Activity Logs — what each MDM user is doing (views + changes)
	async getUserActivityLogs({page = 1, pageSize = 25, startDate, endDate, user_id, module, action, searchTerm} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {start_date: startDate} : {}),
			...(endDate ? {end_date: endDate} : {}),
			...(user_id ? {user_id} : {}),
			...(module ? {module} : {}),
			...(action ? {action} : {}),
			...(searchTerm ? {searchTerm} : {}),
		});
		return this.httpRequest('GET', `/user-activity-logs?${params.toString()}`);
	}

	async getUserActivityModules() {
		return this.httpRequest('GET', `/user-activity-logs/modules`);
	}

	// Export Report View Logs (stream download)
	async exportReportViewLogs({startDate, endDate, distno, reportId} = {}) {
		const params = new URLSearchParams({
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(distno ? {distno} : {}),
			...(reportId ? {reportId} : {}),
		});

		return this.httpRequestBlob('GET', `/report-view-logs/export?${params.toString()}`);
	}

	// Internal Report View Logs API
	async getInternalReportViewLogs({page = 1, pageSize = 20, startDate, endDate, userId, reportId, actionType} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(userId ? {userId} : {}),
			...(reportId ? {reportId} : {}),
			...(actionType ? {actionType} : {}),
		});

		return this.httpRequest('GET', `/internal-report-view-logs?${params.toString()}`);
	}

	// Export Internal Report View Logs (stream download)
	async exportInternalReportViewLogs({startDate, endDate, userId, reportId, actionType} = {}) {
		const params = new URLSearchParams({
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(userId ? {userId} : {}),
			...(reportId ? {reportId} : {}),
			...(actionType ? {actionType} : {}),
		});

		return this.httpRequestBlob('GET', `/internal-report-view-logs/export?${params.toString()}`);
	}

	// Get All Reports
	async getAllReports() {
		return this.httpRequest('GET', `/reports`);
	}

	// STO Loading History (admin view of the Flutter app's sessions)
	async getStoLoadingHistory({page = 0, pageSize = 20, po, status, user_id} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(po ? {po} : {}),
			...(status ? {status} : {}),
			...(user_id ? {user_id} : {}),
		});
		return this.httpRequest('GET', `/sto-app/loading/history?${params.toString()}`);
	}

	async getStoLoadingSession(sessionId) {
		return this.httpRequest('GET', `/sto-app/loading/status/${sessionId}`);
	}

	// Admin override: flip a permanently-closed STO session back to in_progress
	async reopenStoLoadingSession(sessionId) {
		return this.httpRequest('POST', `/sto-app/loading/reopen/${sessionId}`);
	}

	// Re-sync pack_size from the corrected product master for a running session
	// (recomputes scanned_qty from carton count). Returns {changes, session}.
	async refreshStoLoadingPackSize(sessionId) {
		return this.httpRequest('POST', `/sto-app/loading/refresh-pack-size/${sessionId}`);
	}

	// Per-loader × per-SAP-code scan breakdown for a PO (who scanned what/how much)
	async getStoPoLoaderReport(po_no) {
		return this.httpRequest('GET', `/sto-app/loading/report/po-loaders?po_no=${encodeURIComponent(po_no)}`);
	}

	// Same report as an .xlsx download (auth-aware blob download)
	async exportStoPoLoaderReport(po_no) {
		return this.httpRequestBlob(
			'GET',
			`/sto-app/loading/report/po-loaders/export?po_no=${encodeURIComponent(po_no)}`
		);
	}

	// STO Allowed Products — admin allow-list management
	async getStoAllowedProducts({page = 0, pageSize = 20, searchTerm} = {}) {
		const params = new URLSearchParams({
			...(searchTerm ? {searchTerm} : {}),
		});
		return this.httpRequest('GET', `/sto-app/allowed-products/list/${page}/${pageSize}?${params.toString()}`);
	}

	async addStoAllowedProduct(sap_code) {
		return this.httpRequest('POST', `/sto-app/allowed-products/add`, {sap_code});
	}

	async deleteStoAllowedProduct(id) {
		return this.httpRequest('DELETE', `/sto-app/allowed-products/${id}`);
	}

	async getStoAllowedProductDropdown(searchTerm) {
		const params = new URLSearchParams({...(searchTerm ? {searchTerm} : {})});
		return this.httpRequest('GET', `/sto-app/allowed-products/products-dropdown?${params.toString()}`);
	}

	// Sends a POST request to fetch duplicate records details with the given data
	getDuplicateRecordsDetails(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/duplicate-records/details`, data);
	}
	// Update Module Status
	updateModules(id, data) {
		return this.httpRequest('PATCH', `/modules/update-module/${id}`, data);
	}

	// Get All Modules
	getAllListModules() {
		return this.httpRequest('GET', `/modules/get-all-list-modules`);
	}

	// Delete Module by id
	deleteModule(id) {
		return this.httpRequest('DELETE', `/modules/delete-module/${id}`);
	}

	// get module details by id
	getSingleModule(id) {
		return this.httpRequest('GET', `/modules/get-module/${id}`);
	}

	// Enable Info => Enable Pan List
	getEnabledPanList(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bulk-pan-no/get-enabled-list`, data);
	}

	// Disable Info => Disable Pan List
	disableABPanEnableAccount(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bulk-pan-no/disable-pan-enable`, data);
	}

	// Associate Buyer => Enable Bulk Pan Enabled
	enabledBulkUploadedPanList(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bulk-pan-no/enabled-bulk-list`, data);
	}

	// get mdm (ecom) all modules with maintenance mode flag
	getMdmConfig() {
		return this.httpRequest('GET', `/generic/get-mdm-config`);
	}

	// get kyc all modules
	getKycConfig() {
		return this.httpRequest('GET', `/kyc-admin/generic/get-kyc-config`);
	}

	// pan list : API To Make Get Request
	getPanHistoryTrack(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-history/pan-history/get-track-history`, data);
	}

	// bank list : API To Make Get Request
	getBankHistoryTrack(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-history/bank-history/get-track-history`, data);
	}

	// address list : API To Make Get Request
	getAddressHistoryTrack(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-history/address-history/get-track-history`, data);
	}

	// termination list : API To Make Get Request
	getTerminationHistoryTrack(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-history/termination-history/get-track-history`, data);
	}

	// not ok list : API To Make Get Request
	getNotOkHistoryTrack(data) {
		return this.httpRequest('POST', `/kyc-admin/kyc-history/not-ok-history/get-track-history`, data);
	}

	// Termination history list : API To Make Get Request
	getTerminationHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/termination-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// Not Ok history list : API To Make Get Request
	getNotOkHistoryForKyc(params, payload) {
		return this.httpRequest(
			'POST',
			`/kyc-admin/kyc-history/not-ok-history/get-list${
				params?.searchTerm ? `?searchTerm=${params.searchTerm}` : ''
			}`,
			payload
		);
	}

	// Account => account Summary list
	getAccountSummaryList(data) {
		return this.httpRequest('POST', `/accounts/account-summary/get-details`, data);
	}

	// Account => complete ledger list
	getCompleteLedgerList(data) {
		return this.httpRequest('POST', `/accounts/complete-ledger/get-details`, data);
	}

	// Account => AB TDS Tracker list
	getAbTdsTrackerList(data) {
		return this.httpRequest('POST', `/accounts/ab-tds-tracker/get-list`, data);
	}

	// Account => ab accounting list
	getAbAccountingData(data) {
		return this.httpRequest('POST', `/accounts/remaining-balance/get-details`, data);
	}

	// Account => PAN cases list
	getAbPanList(data) {
		return this.httpRequest('POST', `/accounts/ab-pan/get-list`, data);
	}

	// Account => AB PAN summary metrics
	getAbPanSummary() {
		return this.httpRequest('GET', `/accounts/ab-pan/summary`);
	}

	// Account => Approve PAN case
	approveAbPan(data) {
		return this.httpRequest('POST', `/accounts/ab-pan/approve`, data);
	}

	// Account => Sync PAN from bank details
	syncAbPan(data = {}) {
		return this.httpRequest('POST', `/accounts/ab-pan/sync-pan`, data);
	}

	// Account => Enable PAN update for inoperative PAN users
	enableAbPan(data = {}) {
		return this.httpRequest('POST', `/accounts/ab-pan/enable-pan`, data);
	}

	// Account => Trigger inoperative PAN verification
	syncInoperativeAbPan(data = {}) {
		return this.httpRequest('POST', `/accounts/ab-pan/sync-inoperative`, data);
	}

	// Account => AB Invoices list
	getAbInvoicesList(data) {
		return this.httpRequest('POST', `/accounts/ab-invoices/get-list`, data);
	}

	// Account => Update AB Invoice Received Status
	updateAbInvoiceRecvStatus(data) {
		return this.httpRequest('POST', `/accounts/ab-invoices/update-recv-status`, data);
	}

	// Account => Bulk Receive AB Invoices via Excel/CSV
	bulkReceiveAbInvoices(data) {
		return this.httpRequest('POST', `/accounts/ab-invoices/bulk-upload`, data, {multiPart: true});
	}

	// Account => Validate Reverse Payment
	validateReversePaymentUpload(data) {
		return this.httpRequest('POST', `/accounts/reverse-payment/validate-upload`, data, {
			multiPart: true,
		});
	}

	// Account => Commit Reverse Payment
	commitReversePaymentUpload(data) {
		return this.httpRequest('POST', `/accounts/reverse-payment/commit-upload`, data);
	}

	// Account => Get Reverse Payment List
	getReversePaymentList(data) {
		return this.httpRequest('POST', `/accounts/reverse-payment/list`, data);
	}

	// Account => Get Reverse Payment Staging List
	getReversePaymentStagingList(data) {
		return this.httpRequest('POST', `/accounts/reverse-payment/staging-list`, data);
	}

	// Account => Update Reverse Payment Staging Row
	updateReversePaymentStagingRow(data) {
		return this.httpRequest('POST', `/accounts/reverse-payment/staging-list/update`, data);
	}

	// AB Holds APIs
	getAbHoldsList(data) {
		return this.httpRequest('POST', `/accounts/ab-holds/list`, data);
	}

	addAbHold(data) {
		return this.httpRequest('POST', `/accounts/ab-holds/add`, data);
	}

	removeAbHold(data) {
		return this.httpRequest('POST', `/accounts/ab-holds/remove`, data);
	}

	// Commission Cycle APIs
	getCommissionCycleList(data) {
		return this.httpRequest('POST', `/accounts/commission-cycle/list`, data);
	}

	// Cash Bonus Cycle APIs
	getCashBonusCycleList(data) {
		return this.httpRequest('POST', `/accounts/cash-bonus-cycle/list`, data);
	}

	// AB Commission APIs
	getAbCommissionList(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/ab-commission/list`, data);
	}

	exportAbCommissionCsv(data, onProgress) {
		return this.httpRequestStream(
			'POST',
			`/kyc-admin/reports/ab-commission/list`,
			{...data, is_export: true},
			{},
			onProgress
		);
	}

	releaseCommissionCyclePayment(data) {
		return this.httpRequest('POST', `/accounts/commission-cycle/release`, data);
	}

	releaseCashBonusCyclePayment(data) {
		return this.httpRequest('POST', `/accounts/cash-bonus-cycle/release`, data);
	}

	// Business Processing APIs
	getBusinessProcessingList(data) {
		return this.httpRequest('POST', `/accounts/business-processing/list`, data);
	}

	exportBusinessProcessingData(data) {
		return this.httpRequest('POST', `/accounts/business-processing/export`, data);
	}

	exportBusinessProcessingDataByDistNo(data) {
		return this.httpRequest('POST', `/accounts/business-processing/export-by-dist-no`, data);
	}

	uploadHdfcStatementData(data) {
		return this.httpRequest('POST', `/accounts/hdfc-statement-upload/upload`, data, {
			multiPart: true,
		});
	}

	uploadHdfcResponseData(data) {
		return this.httpRequest('POST', `/accounts/hdfc-response-upload`, data, {
			multiPart: true,
		});
	}

	bulkUploadHdfcResponseData(data) {
		return this.httpRequest('POST', `/accounts/hdfc-response-upload/bulk-upload`, data, {
			multiPart: true,
		});
	}

	getHdfcResponseList(data) {
		return this.httpRequest('POST', `/accounts/hdfc-response-upload/list`, data);
	}

	getHdfcResponseDetails(data) {
		return this.httpRequest('POST', `/accounts/hdfc-response-upload/details`, data);
	}

	getHdfcStatementList(data) {
		return this.httpRequest('POST', `/accounts/hdfc-statement-upload/list`, data);
	}

	getSapBusinessReport(data) {
		return this.httpRequest('POST', `/accounts/sap/business/report`, data);
	}

	getSapBusinessReportTypes() {
		return this.httpRequest('GET', `/accounts/sap/business/report-types`);
	}

	exportSapBusinessReport(data) {
		return this.httpRequestBlob('POST', `/accounts/sap/business/export`, data);
	}

	getSapPaymentReport(data) {
		return this.httpRequest('POST', `/accounts/sap/payment/report`, data);
	}

	getSapPaymentReportTypes() {
		return this.httpRequest('GET', `/accounts/sap/payment/report-types`);
	}

	exportSapPaymentReport(data) {
		return this.httpRequestBlob('POST', `/accounts/sap/payment/export`, data);
	}

	getSapTdsReport(data) {
		return this.httpRequest('POST', `/accounts/sap/tds/report`, data);
	}

	exportSapTdsReport(data) {
		return this.httpRequestBlob('POST', `/accounts/sap/tds/export`, data);
	}

	getBusinessProcessingSummary(bank = '', transactionIdArray = null) {
		return this.httpRequest('POST', `/accounts/business-processing/summary`, {
			bank,
			transaction_id_array: transactionIdArray,
		});
	}

	getBusinessProcessingListingSummary() {
		return this.httpRequest('GET', `/accounts/business-processing/listing-summary`);
	}

	pollBusinessProcessingExport(type = '') {
		return this.httpRequest('GET', `/accounts/business-processing/polling${type ? `?type=${type}` : ''}`);
	}

	getGstBusinessProcessingList(data) {
		return this.httpRequest('POST', `/accounts/gst-business-processing/list`, data);
	}

	exportGstBusinessProcessingData(data) {
		return this.httpRequest('POST', `/accounts/gst-business-processing/export`, data);
	}

	getGstBusinessProcessingSummary(bank = '') {
		return this.httpRequest('POST', `/accounts/gst-business-processing/summary`, {bank});
	}

	getGstBusinessProcessingListingSummary() {
		return this.httpRequest('GET', `/accounts/gst-business-processing/listing-summary`);
	}

	exportBeneficiaryData(data) {
		return this.httpRequest('POST', `/accounts/beneficiary-details/export`, data);
	}

	getBeneficiaryExportSummary() {
		return this.httpRequest('GET', `/accounts/beneficiary-details/summary`);
	}

	getBeneficiaryList(data) {
		return this.httpRequest('POST', `/accounts/beneficiary-details/list`, data);
	}

	pollBeneficiaryExport() {
		return this.httpRequest('GET', `/accounts/beneficiary-details/polling`);
	}

	// BANK BOOK SUMMARY API

	getExportJobsSummary() {
		return this.httpRequest('POST', '/accounts/export-jobs/summary');
	}

	deleteExportJob(data) {
		return this.httpRequest('POST', '/accounts/export-jobs/delete-cheque', data);
	}

	getExportJobsDetailedList(data) {
		return this.httpRequest('POST', '/accounts/export-jobs/list', data);
	}

	getMasterBusinessRemarkList(data) {
		return this.httpRequest('POST', '/accounts/commission-remark/list', data);
	}

	getMasterBusinessRemarkSummary(data = {}) {
		return this.httpRequest('POST', '/accounts/commission-remark/summary', data);
	}

	getAbLoanList(data) {
		return this.httpRequest('POST', '/accounts/ab-loan-manager/list', data);
	}

	createAbLoan(data) {
		return this.httpRequest('POST', '/accounts/ab-loan-manager/create', data);
	}

	updateAbLoan(data) {
		return this.httpRequest('POST', '/accounts/ab-loan-manager/edit', data);
	}

	getAbLoanSummary() {
		return this.httpRequest('GET', '/accounts/ab-loan-manager/summary');
	}

	getExportJobsList(params, moduleType = 'business-processing') {
		const queryString = new URLSearchParams(params).toString();
		return this.httpRequest('GET', `/accounts/${moduleType}/export-jobs?${queryString}`);
	}

	async downloadExportJob(data, moduleType = 'business-processing') {
		let token = localStorage.getItem('Authorization');
		// Note: We use fetch directly instead of this.httpRequestBlob because this endpoint
		// can return EITHER a JSON response (containing an S3 URL to redirect to) OR a direct file blob.
		const response = await fetch(`${this.basePath}/accounts/${moduleType}/download`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		});

		if (!response.ok) {
			await this.handleResponseError(response);
			return;
		}

		const contentType = response.headers.get('Content-Type') || '';
		if (contentType.includes('application/json')) {
			return await response.json();
		} else {
			const blob = await response.blob();
			const disposition = response.headers.get('Content-Disposition');
			let filename = `${moduleType}_export.zip`;
			if (disposition && disposition.includes('filename=')) {
				filename = disposition.split('filename=')[1].split(';')[0].replace(/"/g, '');
			}
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
			return {success: true, localBlobDownloaded: true};
		}
	}

	getResponseAvailablePendingCheques(data = {}) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/response-available-pending-cheques`, data);
	}

	getEPlusRejectedUnreversedCheques(data = {}) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/e-plus-rejected-unreversed-cheques`, data);
	}

	getBankBookSummaryList(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/list`, data);
	}

	createManualDistCommissionTransaction(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/create-transaction`, data, {
			multiPart: true,
		});
	}

	getBankBookSummaryByDistList(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/list-by-dist`, data);
	}

	getBankBookSummaryByBankList(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/list-by-bank`, data);
	}

	getBankBookSummaryByDateList(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/list-by-date`, data);
	}

	getSbiBankBookSummaryDetails(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/details/sbi`, data);
	}

	getBankBookSbiDetails(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/details/sbi`, data);
	}

	getHdfcBankBookSummaryDetails(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/details/hdfc`, data);
	}

	getHdfcChequeStatements(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/details/hdfc/statements`, data);
	}

	getHdfcCategorySummary(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/details/hdfc/category-summary`, data);
	}

	updateBankBookSummaryClearDate(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/update-clear-date`, data);
	}

	updateHdfcCheque(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/update-hdfc-cheque`, data);
	}

	reverseBankBookSummaryPayment(data) {
		return this.httpRequest('POST', `/accounts/bank-book-summary/reverse`, data);
	}

	getMasterRcmBankList(data) {
		return this.httpRequest('POST', `/accounts/master-rcm-bank/list`, data);
	}

	//GENERIC API : API call to get book type list
	getBookTypeList() {
		return this.httpRequest('GET', `/kyc-admin/generic/get-book-type`);
	}

	//GENERIC API : API call to get store types list
	getStoreTypes() {
		return this.httpRequest('GET', `/generic/get-store-types`);
	}

	// Mis => not Ok Report list
	getNotOkReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/not-ok-report/get-all-list`, data);
	}

	// Mis => not Ok Report list
	getDeclarationOkReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/declaration-ok-report/get-all-list`, data);
	}

	// Mis => executive feedback list
	getExecutiveFeedbackReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/executive-performance-report/get-all-list`, data);
	}

	// Mis => executive check report list
	getExecutiveCheckReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/executive-check-report/get-all-list`, data);
	}

	// Mis => daily update summary report
	getDailyUpdateSummaryForMis() {
		return this.httpRequest('GET', `/kyc-admin/mis/daily-update-summary`);
	}

	// Mis => Bank and Pan Report
	getBankAndPanReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/bank-pan-report/get-all-list`, data);
	}

	// Mis => Email Check Report
	getEmailCheckReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/email-check-report/get-all-list`, data);
	}

	// Mis => Mobile Check Report
	getMobileCheckReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/mobile-check-report/get-all-list`, data);
	}

	// Mis => Name Check Report
	getNameCheckReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/name-check-report/get-all-list`, data);
	}

	// Mis => Info Check Report
	getInfoCheckReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/info-check-report/get-all-list`, data);
	}

	// Mis => Id Proof Check Report
	getIdProofCheckReportForMis(data) {
		return this.httpRequest('POST', `/kyc-admin/mis/id-proof-check-report/get-all-list`, data);
	}

	downloadReturnOrderItemImage(url) {
		return this.httpRequest('GET', url);
	}

	downloadAssociateBuyerSheetNotification(url) {
		return this.httpRequest('GET', url);
	}

	// API call to get Last Six months state purchase
	getLastSixMonthsStatesPv({searchTerm, state, brand}) {
		return this.httpRequest(
			'GET',
			`/purchaser-in-your-group/group-purchase/six-months-state-group-purchase` +
				(searchTerm ? `?distno=${searchTerm}` : ``) +
				(state ? `&state=${state}` : ``) +
				(brand ? `&brand=${brand}` : ``)
		);
	}

	// API CALL to GET top purchaser
	getTechnicalRoyalty(data) {
		return this.httpRequest('GET', `/technical_group_structure/get-technical-royalty-list/${data}`);
	}

	// API call to get monthly statement v2
	getMonthlyStatementV2(data) {
		return this.httpRequest('POST', `/monthly-statement/get-monthly-statement-v2`, data);
	}

	// Product Price List API
	async getProductPriceList({
		page = 1,
		pageSize = 10,
		state_code,
		searchTerm,
		category,
		isdownload,
		download_type,
	} = {}) {
		const params = new URLSearchParams({
			...(state_code ? {state_code} : {}),
			...(searchTerm ? {searchTerm: encodeURIComponent(searchTerm)} : {}),
			...(category ? {category} : {}),
			...(isdownload ? {isdownload: 'true'} : {}),
			...(download_type ? {download_type} : {}),
		});

		return this.httpRequest('GET', `/product-price-list/${page}/${pageSize}?${params.toString()}`);
	}

	// Enable Info: enable bank account for verification
	enableBankAccountForVerification(request) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/verification/update-bank-enable`, request);
	}

	// Enable Info: enable pan for verification
	enablePanForVerification(request) {
		return this.httpRequest('POST', `/kyc-admin/kyc-mod/verification/update-pan-enable`, request);
	}

	// Store Feedback Report API
	getStoreFeedbackReport({page = 1, pageSize = 10, startDate, endDate, storeCode, isExport} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(storeCode ? {storeCode} : {}),
			...(isExport ? {isExport: 'true'} : {}),
		});

		return this.httpRequest('GET', `/store-feedback?${params.toString()}`);
	}

	//   Get Users By Module Access
	getUsersByModule(moduleId) {
		return this.httpRequest('GET', `/modules/get-module-users/${moduleId}`);
	}

	// Schedule Management Module
	createSchedule(data) {
		return this.httpRequest('POST', `/schedules`, data);
	}

	getAllSchedules(params) {
		return this.httpRequest('GET', `/schedules`, null, params);
	}

	getScheduleById(id) {
		return this.httpRequest('GET', `/schedules/${id}`);
	}

	updateSchedule(id, data) {
		return this.httpRequest('PUT', `/schedules/${id}`, data);
	}

	cancelSchedule(id) {
		return this.httpRequest('PUT', `/schedules/${id}/cancel`);
	}

	getScheduleExecutionLogs(scheduleId, params) {
		return this.httpRequest('GET', `/schedules/${scheduleId}/logs`, null, params);
	}
	// Post Purchase Feedback Report API
	getPostPurchaseFeedbackReport({page = 1, pageSize = 10, startDate, endDate, isExport} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(isExport ? {isExport: 'true'} : {}),
		});

		return this.httpRequest('GET', `/post-purchase-feedback?${params.toString()}`);
	}

	// Sehat ke Sitaare - Listing API
	getSehatKeSitaareList({
		page = 1,
		pageSize = 10,
		search,
		isExport,
		abNumber,
		abName,
		fillingFor,
		relation,
		healthConditions,
		reportStatus,
		filterMonth,
	} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(search ? {search} : {}),
			...(isExport ? {isExport: 'true'} : {}),
			...(abNumber ? {abNumber} : {}),
			...(abName ? {abName} : {}),
			...(fillingFor ? {fillingFor} : {}),
			...(relation ? {relation} : {}),
			...(healthConditions ? {healthConditions} : {}),
			...(reportStatus ? {reportStatus} : {}),
			...(filterMonth ? {filterMonth} : {}),
		});

		return this.httpRequest('GET', `/sehat-ke-sitaare?${params.toString()}`);
	}

	// Get Master Relations for dropdown/filters
	getRelationShips() {
		return this.httpRequest('GET', `/sehat-ke-sitaare/master/relations`);
	}

	// Sehat ke Sitare Reports APIs
	getSehatKeSitaareReport(reportId) {
		return this.httpRequest('GET', `/sehat-ke-sitaare/reports/${reportId}`);
	}

	getSehatKeSitaareReports(sehatKeSitareId, day = null) {
		let url = `/sehat-ke-sitaare/reports/${sehatKeSitareId}/view`;

		if (day) url += `?day=${day}`;

		return this.httpRequest('GET', url);
	}

	approveSehatKeSitaareReport(reportId, data = {}) {
		return this.httpRequest('POST', `/sehat-ke-sitaare/reports/${reportId}/approve`, data);
	}

	rejectSehatKeSitaareReport(reportId, data) {
		return this.httpRequest('POST', `/sehat-ke-sitaare/reports/${reportId}/reject`, data);
	}

	revertSehatKeSitaareReport(reportId, data) {
		return this.httpRequest('POST', `/sehat-ke-sitaare/reports/${reportId}/revert`, data);
	}

	scheduleDay90Report(reportId, data) {
		return this.httpRequest('POST', `/sehat-ke-sitaare/reports/${reportId}/schedule-day-90`, data);
	}

	uploadReportDocument(reportId, data) {
		return this.httpRequest('POST', `/sehat-ke-sitaare/reports/${reportId}/upload-document`, data);
	}

	// Disease Management APIs
	getSehatKeSitareDiseases({page = 1, pageSize = 10, search, status} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(search ? {search} : {}),
			...(status ? {status} : {}),
		});
		return this.httpRequest('GET', `/sehat-ke-sitaare/diseases?${params.toString()}`);
	}

	getSehatKeSitareDiseaseById(diseaseId) {
		return this.httpRequest('GET', `/sehat-ke-sitaare/diseases/${diseaseId}`);
	}

	getActiveSehatKeSitareDiseases() {
		return this.httpRequest('GET', `/sehat-ke-sitaare/diseases/active`);
	}

	createSehatKeSitareDisease(data) {
		return this.httpRequest('POST', `/sehat-ke-sitaare/diseases`, data);
	}

	updateSehatKeSitareDisease(diseaseId, data) {
		return this.httpRequest('PUT', `/sehat-ke-sitaare/diseases/${diseaseId}`, data);
	}

	deleteSehatKeSitareDisease(diseaseId) {
		return this.httpRequest('DELETE', `/sehat-ke-sitaare/diseases/${diseaseId}`);
	}

	// ─── Sehat Mitra ─────────────────────────────────────────────────────────────

	getSehatMitraList({
		page = 1,
		pageSize = 10,
		search,
		isExport,
		mobileNumber,
		beneficiaryName,
		healthConditions,
		reportStatus,
		filterMonth,
	} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(search ? {search} : {}),
			...(isExport ? {isExport: 'true'} : {}),
			...(mobileNumber ? {mobileNumber} : {}),
			...(beneficiaryName ? {beneficiaryName} : {}),
			...(healthConditions ? {healthConditions} : {}),
			...(reportStatus ? {reportStatus} : {}),
			...(filterMonth ? {filterMonth} : {}),
		});
		return this.httpRequest('GET', `/sehat-mitra?${params.toString()}`);
	}

	getSehatMitraReports(sehatMitraId, day = null) {
		let url = `/sehat-mitra/reports/${sehatMitraId}/view`;
		if (day) url += `?day=${day}`;
		return this.httpRequest('GET', url);
	}

	getSehatMitraReport(reportId) {
		return this.httpRequest('GET', `/sehat-mitra/reports/${reportId}`);
	}

	approveSehatMitraReport(reportId, data = {}) {
		return this.httpRequest('POST', `/sehat-mitra/reports/${reportId}/approve`, data);
	}

	rejectSehatMitraReport(reportId, data) {
		return this.httpRequest('POST', `/sehat-mitra/reports/${reportId}/reject`, data);
	}

	revertSehatMitraReport(reportId, data) {
		return this.httpRequest('POST', `/sehat-mitra/reports/${reportId}/revert`, data);
	}

	scheduleSehatMitraDay90Report(reportId, data) {
		return this.httpRequest('POST', `/sehat-mitra/reports/${reportId}/schedule-day-90`, data);
	}

	getSehatMitraUserInfoByDisease(reportId) {
		return this.httpRequest('GET', `/sehat-mitra/user-info-by-disease/${reportId}`);
	}

	getSehatMitraDiseases({page = 1, pageSize = 10, search, status} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(search ? {search} : {}),
			...(status ? {status} : {}),
		});
		return this.httpRequest('GET', `/sehat-mitra/diseases?${params.toString()}`);
	}

	getSehatMitraDiseaseById(diseaseId) {
		return this.httpRequest('GET', `/sehat-mitra/diseases/${diseaseId}`);
	}

	getActiveSehatMitraDiseases() {
		return this.httpRequest('GET', `/sehat-mitra/diseases/active`);
	}

	createSehatMitraDisease(data) {
		return this.httpRequest('POST', `/sehat-mitra/diseases`, data);
	}

	updateSehatMitraDisease(diseaseId, data) {
		return this.httpRequest('PUT', `/sehat-mitra/diseases/${diseaseId}`, data);
	}

	deleteSehatMitraDisease(diseaseId) {
		return this.httpRequest('DELETE', `/sehat-mitra/diseases/${diseaseId}`);
	}

	// New Joiner Feedback Report API
	getNewJoinerFeedbackReport({page = 1, pageSize = 10, startDate, endDate, isExport} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
			...(isExport ? {isExport: 'true'} : {}),
		});

		return this.httpRequest('GET', `/new-joiner-feedback?${params.toString()}`);
	}

	// Targeted Notification APIs
	createTargetedNotification(data, multiPart = true) {
		return this.httpRequest('POST', `/targeted_notification_list`, data, {multiPart});
	}
	getTargetedNotificationById(id) {
		return this.httpRequest('GET', `/targeted_notification_list/${id}`);
	}
	previewAudienceCount(data) {
		return this.httpRequest('POST', `/targeted_notification_list/preview-count`, data);
	}
	sendTargetedNotification(id) {
		return this.httpRequest('PUT', `/targeted_notification_list/send/${id}`);
	}
	deleteTargetedNotification(data) {
		return this.httpRequest('DELETE', `/targeted_notification_list`, data);
	}

	// Notification Templates
	getAllNotificationTemplates(data) {
		return this.httpRequest('POST', `/notification_templates/getAll`, data);
	}
	getActiveNotificationTemplates() {
		return this.httpRequest('GET', `/notification_templates/getActive`);
	}
	getNotificationTemplateById(id) {
		return this.httpRequest('GET', `/notification_templates/${id}`);
	}
	addNotificationTemplate(data) {
		return this.httpRequest('POST', `/notification_templates/add`, data);
	}
	updateNotificationTemplate(id, data) {
		return this.httpRequest('PUT', `/notification_templates/${id}`, data);
	}
	deleteNotificationTemplate(data) {
		return this.httpRequest('POST', `/notification_templates/delete`, data);
	}
	// Targeted Notification Lookup APIs
	getTargetedNotifStates() {
		return this.httpRequest('GET', `/targeted_notification_list/lookup/states`);
	}
	getTargetedNotifDistricts(stateName) {
		return this.httpRequest(
			'GET',
			`/targeted_notification_list/lookup/districts?state_name=${encodeURIComponent(stateName)}`
		);
	}
	getTargetedNotifPincodes(district) {
		return this.httpRequest(
			'GET',
			`/targeted_notification_list/lookup/pincodes?district=${encodeURIComponent(district)}`
		);
	}
	getTargetedNotifProducts(searchTerm) {
		return this.httpRequest(
			'GET',
			`/targeted_notification_list/lookup/products?searchTerm=${encodeURIComponent(searchTerm)}`
		);
	}
	getTargetedNotifBrands() {
		return this.httpRequest('GET', `/targeted_notification_list/lookup/brands`);
	}
	getTargetedNotifCategories() {
		return this.httpRequest('GET', `/targeted_notification_list/lookup/categories`);
	}
	initiateVoiceBroadcastCampaign(data) {
		return this.httpRequest('POST', `/voicebroadcast/initiate-campaign`, data);
	}
	checkVoiceBroadcastTargetCount(data) {
		return this.httpRequest('POST', `/voicebroadcast/check-target-count`, data);
	}
	initiateVoiceBroadcastCampaignUpload(formData) {
		return this.httpRequest('POST', `/voicebroadcast/initiate-campaign-upload`, formData, {
			multiPart: true,
		});
	}
	voiceBroadcastCampaignList(params) {
		return this.httpRequest('GET', `/voicebroadcast/all?${params}`);
	}
	voiceBroadcastCampaignLogs(params) {
		return this.httpRequest('GET', `/voicebroadcast/logs?${params}`);
	}
	sendVoiceBroadcastToQueue(campaignId) {
		return this.httpRequest('POST', `/voicebroadcast/send-to-queue/${campaignId}`, {});
	}
	exportVoiceBroadcastSuccessCallLogs(campaignId) {
		return this.httpRequest('GET', `/voicebroadcast/export-success-call-logs/${campaignId}`);
	}
	exportVoiceBroadcastFailureCallLogs(campaignId) {
		return this.httpRequest('GET', `/voicebroadcast/export-failure-call-logs/${campaignId}`);
	}
	getVoiceBroadcastCallLogsExportStatus(jobId) {
		return this.httpRequest('GET', `/voicebroadcast/export-call-logs/status/${jobId}`);
	}
	downloadVoiceBroadcastCallLogsExport(jobId) {
		return this.httpRequestBlob('GET', `/voicebroadcast/export-call-logs/download/${jobId}`);
	}
	placeVoiceBroadcastTestCall({mobile, campaign, tts}) {
		return this.httpRequest('POST', `/voicebroadcast/test-call`, {
			mobile,
			campaign,
			tts,
		});
	}
	retryVoiceBroadcastCampaign(campaignId) {
		return this.httpRequest('POST', `/voicebroadcast/retry/${campaignId}`, {});
	}
	getVoiceBroadcastReport(campaignId, params) {
		const query = new URLSearchParams(params).toString();
		return this.httpRequest('GET', `/voicebroadcast/report/${campaignId}?${query}`);
	}
	deleteVoiceBroadcastCampaign(campaignId) {
		return this.httpRequest('DELETE', `/voicebroadcast/${campaignId}`);
	}

	getVoiceBroadcastDashboardStats(campaignId) {
		return this.httpRequest('GET', `/voicebroadcast/report/dashboard/${campaignId}`);
	}
	exportVoiceBroadcastReport(campaignId, params) {
		const query = new URLSearchParams(params).toString();
		return this.httpRequestBlob('GET', `/voicebroadcast/report/export/${campaignId}?${query}`);
	}

	exportVoiceBroadcastReportJob(campaignId, params) {
		const query = new URLSearchParams(params).toString();
		return this.httpRequest('POST', `/voicebroadcast/report/export-job/${campaignId}?${query}`, null);
	}

	getVoiceBroadcastReportJobStatus(jobId) {
		return this.httpRequest('GET', `/voicebroadcast/report/export-job/status/${jobId}`, null);
	}

	downloadVoiceBroadcastReportJob(jobId) {
		return this.httpRequestBlob('GET', `/voicebroadcast/report/export-job/download/${jobId}`, null);
	}

	// Call Center Reports - get Hygiene Camapigns list
	getHygieneCampaignsList(page, pageSize, startDate, endDate) {
		const start = startDate ? `&startDate=${startDate}` : '';
		const end = endDate ? `&endDate=${endDate}` : '';
		return this.httpRequest(
			'GET',
			`/call-center-reports/hygiene-campaigns/list/${page}/${pageSize}?${start}${end}`,
			null
		);
	}
	// ----------------------------------------------------------------------
	// PINCODE SCHEDULE MODULE
	// ----------------------------------------------------------------------

	// Get all Pincode Schedules with pagination and search
	getAllPincodeSchedules(page, pageSize, searchTerm = '') {
		// If searchTerm is empty/undefined, we still pass it as a query param so the backend handles it gracefully
		return this.httpRequest(
			'GET',
			`/pincodemaps/schedule/all/${page}/${pageSize}?searchTerm=${encodeURIComponent(searchTerm)}`
		);
	}

	// Get a single Pincode Schedule by ID
	getSinglePincodeSchedule(id) {
		return this.httpRequest('GET', `/pincodemaps/schedule/${id}`);
	}

	// Add a new Pincode Schedule
	addPincodeSchedule(payload) {
		return this.httpRequest('POST', `/pincodemaps/add-schedule/new`, payload);
	}

	// Update an existing Pincode Schedule
	updatePincodeSchedule(id, payload) {
		return this.httpRequest('PUT', `/pincodemaps/schedule/${id}`, payload);
	}

	// Delete Pincode Schedule
	deletePincodeSchedule(id) {
		return this.httpRequest(
			'DELETE',
			`/pincodemaps/schedule/${id}` // Pass ID in the URL
		);
	}

	// Mashal Report: Get paginated data with optional AB ID filter
	getMashalReportData(params) {
		let endpoint = '/report/mashal-report/';

		if (params?.page !== undefined && params?.pageSize !== undefined) {
			endpoint += `${params.page}/${params.pageSize}`;
		}

		// Add ab_id query parameter if provided
		const queryParams = new URLSearchParams();
		if (params?.ab_id) {
			queryParams.append('ab_id', params.ab_id);
		}

		const queryString = queryParams.toString();
		if (queryString) {
			endpoint += `?${queryString}`;
		}

		return this.httpRequest('GET', endpoint);
	}

	// Mashal Report: Export all data with optional AB ID filter
	exportMashalReportData(params) {
		let endpoint = '/report/mashal-report/export';

		// Add ab_id query parameter if provided
		const queryParams = new URLSearchParams();
		if (params?.ab_id) {
			queryParams.append('ab_id', params.ab_id);
		}

		const queryString = queryParams.toString();
		if (queryString) {
			endpoint += `?${queryString}`;
		}

		return this.httpRequest('GET', endpoint);
	}

	// Zonal Sales User
	getSalesUserList(apiUrl, payload) {
		return this.httpRequest('POST', apiUrl, payload);
	}

	getSalesUserById(id) {
		return this.httpRequest('GET', `/zonal-sales-user/get/${id}`);
	}

	createSalesUser(data) {
		return this.httpRequest('POST', `/zonal-sales-user/create`, data);
	}

	updateSalesUser(id, data) {
		return this.httpRequest('PUT', `/zonal-sales-user/update/${id}`, data);
	}

	deleteSalesUser(data) {
		return this.httpRequest('POST', `/zonal-sales-user/delete`, data);
	}

	getAssignedDistricts(excludeUserId) {
		const param = excludeUserId ? `?excludeUserId=${excludeUserId}` : '';
		return this.httpRequest('GET', `/zonal-sales-user/assigned-districts${param}`);
	}

	getDistrictsByStateCode(stateCode) {
		return this.httpRequest('GET', `/zonal-sales-user/districts-by-state?stateCode=${stateCode}`);
	}

	searchSalesUserAssignments(zone, stateCode, distCode) {
		const params = new URLSearchParams();
		if (zone) params.append('zone', zone);
		if (stateCode) params.append('stateCode', stateCode);
		if (distCode) params.append('distCode', distCode);
		return this.httpRequest('GET', `/zonal-sales-user/search-assignments?${params.toString()}`);
	}

	// Zonal Observation Checklist
	getObservationSections() {
		return this.httpRequest('GET', `/zonal-observation/sections`);
	}

	createObservationSection(data) {
		return this.httpRequest('POST', `/zonal-observation/sections/create`, data);
	}

	updateObservationSection(id, data) {
		return this.httpRequest('PUT', `/zonal-observation/sections/update/${id}`, data);
	}

	deleteObservationSection(id) {
		return this.httpRequest('DELETE', `/zonal-observation/sections/delete/${id}`);
	}

	getObservationQuestions(payload) {
		return this.httpRequest('POST', `/zonal-observation/questions/get-list`, payload);
	}

	getObservationQuestionsBySection(sectionId) {
		return this.httpRequest('GET', `/zonal-observation/questions/by-section/${sectionId}`);
	}

	createObservationQuestion(data) {
		return this.httpRequest('POST', `/zonal-observation/questions/create`, data);
	}

	updateObservationQuestion(id, data) {
		return this.httpRequest('PUT', `/zonal-observation/questions/update/${id}`, data);
	}

	deleteObservationQuestion(id) {
		return this.httpRequest('DELETE', `/zonal-observation/questions/delete/${id}`);
	}
	getSehatKeSitaareReportsUserInfo(sehatKeSitareId) {
		return this.httpRequest('GET', `/sehat-ke-sitaare/user-info-by-disease/${sehatKeSitareId}`);
	}

	// KYC Super Admin Report View Logs
	async getKycReportViewLogs(data = {}) {
		return this.httpRequest('POST', `/kyc-super-admin/report-view-logs/get-all`, data);
	}
	// update Ecom users for permission
	fetchEcomUserActionLogs(userId) {
		return this.httpRequest('GET', `/ecom-user-permission/fetch-user-action-logs/${userId}`);
	}

	// ===================== Post / Courier receipt module =====================

	// Lookups
	getPostUserDropdown(searchTerm = '') {
		const qs = searchTerm ? `?searchTerm=${encodeURIComponent(searchTerm)}` : '';
		return this.httpRequest('GET', `/post/lookups/users${qs}`);
	}
	getPostABInfo(abId) {
		return this.httpRequest('GET', `/post/lookups/ab/${encodeURIComponent(abId)}`);
	}
	getPostStoreInfo(storeCode) {
		return this.httpRequest('GET', `/post/lookups/store/${encodeURIComponent(storeCode)}`);
	}

	// Couriers (master)
	getCourierDropdown() {
		return this.httpRequest('GET', `/post/couriers/dropdown`);
	}
	getAllCouriers(page = 0, pageSize = 10, searchTerm = '') {
		const qs = searchTerm ? `?searchTerm=${encodeURIComponent(searchTerm)}` : '';
		return this.httpRequest('GET', `/post/couriers/all/${page}/${pageSize}${qs}`);
	}
	getCourierById(id) {
		return this.httpRequest('GET', `/post/couriers/${id}`);
	}
	addCourier(body) {
		return this.httpRequest('POST', `/post/couriers`, body);
	}
	updateCourier(id, body) {
		return this.httpRequest('PUT', `/post/couriers/${id}`, body);
	}
	deleteCouriers(courierIds) {
		return this.httpRequest('DELETE', `/post/couriers`, {courierIds});
	}

	// Post Entries
	getAllPostEntries(page = 0, pageSize = 10, filterTerm = null, searchTerm = '') {
		const params = new URLSearchParams();
		if (filterTerm) params.set('filterTerm', JSON.stringify(filterTerm));
		if (searchTerm) params.set('searchTerm', searchTerm);
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.httpRequest('GET', `/post/entries/all/${page}/${pageSize}${qs}`);
	}
	getPostEntryById(id) {
		return this.httpRequest('GET', `/post/entries/${id}`);
	}
	getPostHandoverLog(id) {
		return this.httpRequest('GET', `/post/entries/${id}/handover-log`);
	}
	addPostEntry(body) {
		return this.httpRequest('POST', `/post/entries`, body);
	}
	updatePostEntry(id, body) {
		return this.httpRequest('PUT', `/post/entries/${id}`, body);
	}
	changePostStatus(id, body) {
		return this.httpRequest('PATCH', `/post/entries/${id}/status`, body);
	}
	reassignPostEntry(id, body) {
		return this.httpRequest('PATCH', `/post/entries/${id}/reassign`, body);
	}
	deletePostEntries(postIds) {
		return this.httpRequest('DELETE', `/post/entries`, {postIds});
	}

	// Dashboard + Report download
	getPostDashboard(filters = {}) {
		const params = new URLSearchParams();
		Object.entries(filters).forEach(([k, v]) => v && params.set(k, v));
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.httpRequest('GET', `/post/dashboard${qs}`);
	}
	downloadPostReport(filters = {}) {
		const params = new URLSearchParams();
		Object.entries(filters).forEach(([k, v]) => v && params.set(k, v));
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.httpRequestBlob('GET', `/post/report/download${qs}`);
	}
	// KYC Admin - Enable/Disable History Tracks
	getEnableBankHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank/get-track`, data);
	}

	// Enable Info => Enable Pan History Tracks
	getEnablePanHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/pan/get-track`, data);
	}

	// Disable Info => Disable Bank History Tracks
	getDisableBankHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/disable-info/bank-acc/get-track`, data);
	}

	// Disable Info => Disable Pan History Tracks
	getDisablePanHistoryTracks(data) {
		return this.httpRequest('POST', `/kyc-admin/disable-info/pan-no/get-track`, data);
	}

	// ===================== QR Generator (sticker printing) =====================
	getQRProductDropdown(searchTerm = '') {
		const qs = searchTerm ? `?searchTerm=${encodeURIComponent(searchTerm)}` : '';
		return this.httpRequest('GET', `/qr/products/dropdown${qs}`);
	}
	generateQRCodes(body) {
		// body: { sap_code, count, mfg_date }
		return this.httpRequest('POST', `/qr/generate`, body);
	}
	getAllQRCodes(page = 0, pageSize = 10, filterTerm = null, searchTerm = '') {
		const params = new URLSearchParams();
		if (filterTerm) params.set('filterTerm', JSON.stringify(filterTerm));
		if (searchTerm) params.set('searchTerm', searchTerm);
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.httpRequest('GET', `/qr/list/${page}/${pageSize}${qs}`);
	}
	getQRBatch(batchId) {
		return this.httpRequest('GET', `/qr/batch/${batchId}`);
	}
	saveQRBatchPrintLayout(batchId, body) {
		// body: { sheet_key, sheet } — remembers the label sheet a batch was
		// printed on so a later re-print comes out on the same stationery.
		return this.httpRequest('POST', `/qr/batch/${batchId}/print`, body);
	}

	// ===================== Consistency Calculator =====================
	// Single-AB "what-if" — read-only, no DB write.
	calculateConsistency(body) {
		// body: { months: [M1, M2, M3, M4, M5, M6] }
		return this.httpRequest('POST', `/consistency/calculate`, body);
	}
	uploadConsistencyBatch(body) {
		// body: { start_month: 'YYYY-MM', label?, rows: [...], source_file_name? }
		return this.httpRequest('POST', `/consistency/upload`, body);
	}
	uploadConsistencyBatchExcel(formData) {
		// formData fields: batch_file (xlsx File), start_month, label?
		return this.httpRequest('POST', `/consistency/upload-excel`, formData, {multiPart: true});
	}
	parseConsistencyExcel(formData) {
		// formData: batch_file (xlsx), start_month? (for month-name header detection)
		// Returns cacheKey + total_count + preview rows (no engine).
		return this.httpRequest('POST', `/consistency/parse-excel`, formData, {multiPart: true});
	}
	calculateConsistencyBatch({cacheKey, rows}) {
		// Prefer { cacheKey } — the server already has the full row set.
		// The { rows } shape is kept as a backward-compat path for small tests.
		const body = cacheKey ? {cacheKey} : {rows};
		return this.httpRequest('POST', `/consistency/calculate-batch`, body);
	}
	persistCachedConsistencyBatch({cacheKey, start_month, label}) {
		return this.httpRequest('POST', `/consistency/persist-cached`, {
			cacheKey,
			start_month,
			label: label || null,
		});
	}
	downloadConsistencyTemplate() {
		return this.httpRequestBlob('GET', `/consistency/template`, null);
	}
	downloadConsistencyPeriod(periodId) {
		return this.httpRequestBlob('GET', `/consistency/period/${periodId}/download`, null);
	}
	listConsistencyPeriods(page = 0, pageSize = 20, searchTerm = '') {
		const qs = searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : '';
		return this.httpRequest('GET', `/consistency/periods/${page}/${pageSize}${qs}`);
	}
	getConsistencyPeriod(periodId) {
		return this.httpRequest('GET', `/consistency/period/${periodId}`);
	}
	listConsistencyEntries(periodId, opts = {}) {
		const params = new URLSearchParams();
		if (opts.page != null) params.set('page', opts.page);
		if (opts.pageSize != null) params.set('pageSize', opts.pageSize);
		if (opts.search) params.set('search', opts.search);
		if (opts.slab) params.set('slab', opts.slab);
		if (opts.only_cycle_broken) params.set('only_cycle_broken', 'true');
		if (opts.only_downgraded) params.set('only_downgraded', 'true');
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.httpRequest('GET', `/consistency/period/${periodId}/entries${qs}`);
	}
	deleteConsistencyPeriod(periodId) {
		return this.httpRequest('DELETE', `/consistency/period/${periodId}`);
	}

	// ===================== Cash Bonus =====================
	calculateCashBonus(body) {
		return this.httpRequest('POST', `/cash-bonus/calculate`, body);
	}
	uploadCashBonusBatch(body) {
		return this.httpRequest('POST', `/cash-bonus/upload`, body);
	}
	uploadCashBonusBatchExcel(formData) {
		return this.httpRequest('POST', `/cash-bonus/upload-excel`, formData, {multiPart: true});
	}
	parseCashBonusExcel(formData) {
		return this.httpRequest('POST', `/cash-bonus/parse-excel`, formData, {multiPart: true});
	}
	calculateCashBonusBatch({cacheKey, rows}) {
		const body = cacheKey ? {cacheKey} : {rows};
		return this.httpRequest('POST', `/cash-bonus/calculate-batch`, body);
	}
	persistCachedCashBonusBatch({cacheKey, start_month, label}) {
		return this.httpRequest('POST', `/cash-bonus/persist-cached`, {
			cacheKey,
			start_month,
			label,
		});
	}
	downloadCashBonusTemplate() {
		return this.httpRequestBlob('GET', `/cash-bonus/template`, null);
	}
	downloadCashBonusPeriod(periodId) {
		return this.httpRequestBlob('GET', `/cash-bonus/period/${periodId}/download`, null);
	}
	listCashBonusPeriods(page = 0, pageSize = 20, searchTerm = '') {
		const qs = searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : '';
		return this.httpRequest('GET', `/cash-bonus/periods/${page}/${pageSize}${qs}`);
	}
	getCashBonusPeriod(periodId) {
		return this.httpRequest('GET', `/cash-bonus/period/${periodId}`);
	}
	listCashBonusEntries(periodId, opts = {}) {
		const params = new URLSearchParams();
		if (opts.page != null) params.set('page', String(opts.page));
		if (opts.pageSize != null) params.set('pageSize', String(opts.pageSize));
		if (opts.searchTerm) params.set('search', opts.searchTerm);
		if (opts.slab) params.set('slab', opts.slab);
		if (opts.only_cycle_broken) params.set('only_cycle_broken', 'true');
		const qs = params.toString() ? `?${params.toString()}` : '';
		return this.httpRequest('GET', `/cash-bonus/period/${periodId}/entries${qs}`);
	}
	deleteCashBonusPeriod(periodId) {
		return this.httpRequest('DELETE', `/cash-bonus/period/${periodId}`);
	}

	// --- Nirjara Admin Operations ---
	getNirjaraAdminStats() {
		return this.httpRequest('GET', `/nirjara/stats`);
	}

	getNirjaraAdminSubmissions(
		page = 1,
		pageSize = 10,
		searchTerm = '',
		status = 'all',
		phase = 'all',
		dateRange = [],
		isDownload = false
	) {
		// Standardizing the route to match your Udaan pattern
		let url = `/nirjara/submissions/${page}/${pageSize}?`;

		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (status && status !== 'all') {
			url += `&status=${encodeURIComponent(status)}`;
		}
		if (phase && phase !== 'all') {
			url += `&phase=${encodeURIComponent(phase)}`;
		}
		// Add Date Filters
		if (dateRange && dateRange.length === 2 && dateRange[0] !== '' && dateRange[1] !== '') {
			url += `&startDate=${dateRange[0]}&endDate=${dateRange[1]}`;
		}
		if (isDownload) {
			url += `&isDownload=${encodeURIComponent(isDownload)}`;
		}
		return this.httpRequest('GET', url);
	}

	getNirjaraSubmissionDetails(id, submitted) {
		return this.httpRequest('GET', `/nirjara/submissions/${id}?`);
	}

	updateNirjaraSubmissionStatus(id, payload) {
		return this.httpRequest('PUT', `/nirjara/status/submissions/${id}`, payload);
	}

	clearKycReportCache() {
		return this.httpRequest('DELETE', `/mdm-settings/clear-kyc-cache`);
	}

	// ===================== Sewa Diwas APIs =====================
	getSewaDiwasPreEventsList({
		page = 1,
		pageSize = 10,
		search,
		idno,
		name,
		reg_no,
		state,
		district,
		startDate,
		endDate,
	} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(search ? {search} : {}),
			...(idno ? {idno} : {}),
			...(name ? {name} : {}),
			...(reg_no ? {reg_no} : {}),
			...(state ? {state} : {}),
			...(district ? {district} : {}),
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
		});
		return this.httpRequest('GET', `/sewa-diwas/pre-events?${params.toString()}`);
	}

	updateSewaDiwasPreEvent(id, payload) {
		return this.httpRequest('PUT', `/sewa-diwas/pre-event/${id}`, payload);
	}

	getSewaDiwasPostEventsList({
		page = 1,
		pageSize = 10,
		search,
		idno,
		name,
		reg_no,
		state,
		district,
		startDate,
		endDate,
	} = {}) {
		const params = new URLSearchParams({
			page,
			pageSize,
			...(search ? {search} : {}),
			...(idno ? {idno} : {}),
			...(name ? {name} : {}),
			...(reg_no ? {reg_no} : {}),
			...(state ? {state} : {}),
			...(district ? {district} : {}),
			...(startDate ? {startDate} : {}),
			...(endDate ? {endDate} : {}),
		});
		return this.httpRequest('GET', `/sewa-diwas/post-events?${params.toString()}`);
	}

	updateSewaDiwasPostEvent(id, payload) {
		return this.httpRequest('PUT', `/sewa-diwas/post-event/${id}`, payload);
	}
	exportSewaDiwasPreEvents(filters = {}) {
		const params = new URLSearchParams();
		Object.entries(filters).forEach(([k, v]) => v && params.set(k, v));
		if (filters.format === 'pdf' || filters.format === 'json') {
			return this.httpRequest('GET', `/sewa-diwas/export/pre-events?${params.toString()}`);
		}
		return this.httpRequestBlob('GET', `/sewa-diwas/export/pre-events?${params.toString()}`);
	}

	exportSewaDiwasPostEvents(filters = {}) {
		const params = new URLSearchParams();
		Object.entries(filters).forEach(([k, v]) => v && params.set(k, v));
		if (filters.format === 'pdf' || filters.format === 'json') {
			return this.httpRequest('GET', `/sewa-diwas/export/post-events?${params.toString()}`);
		}
		return this.httpRequestBlob('GET', `/sewa-diwas/export/post-events?${params.toString()}`);
	}
	// report : upload AB numbers for bulk details lookup
	uploadAbBulkDetailsReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/bulk-ab-details/get-list`, data);
	}

	// Pin Growth Analysis Report
	getPinGrowthAnalysisReport(data) {
		return this.httpRequest('POST', `/kyc-admin/reports/pin-growth-analysis/get-list`, data);
	}

	// Increase mobile count: Get AB details
	getAbDetailsForMobileCount(data) {
		return this.httpRequest('POST', `/kyc-super-admin/mobile-count/get`, data);
	}

	// Increase mobile count: increment max mobile updates by 1
	increaseMaxMobileCount(data) {
		return this.httpRequest('POST', `/kyc-super-admin/mobile-count/update`, data);
	}

	// Update mobile count (Associate Buyers): Get comprehensive AB details
	getAbDetailsForUpdateMobileCount(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/update-mobile-count/get`, data);
	}

	// Update mobile count (Associate Buyers): Get mobile number history
	getAbMobileHistoryForUpdateMobileCount(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/update-mobile-count/get-mobile-history`, data);
	}

	// Update mobile count (Associate Buyers): Get KYC tracking for mobile
	getAbKycTrackingForUpdateMobileCount(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/update-mobile-count/get-kyc-tracking`, data);
	}

	// Update mobile count (Associate Buyers): Increase/Update max mobile count
	updateMobileCount(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/update-mobile-count/update`, data);
	}

	// ─── Genie: Master Company Targets ───────────────────────────────────────
	getGenieCompanyTargets() {
		return this.httpRequest('GET', `/genie/master-company-targets`, null);
	}
	getGenieCompanyTargetById(id) {
		return this.httpRequest('GET', `/genie/master-company-targets/${id}`, null);
	}
	createGenieCompanyTarget(data) {
		return this.httpRequest('POST', `/genie/master-company-targets`, data);
	}
	updateGenieCompanyTarget(data, id) {
		return this.httpRequest('PUT', `/genie/master-company-targets/${id}`, data);
	}
	deleteGenieCompanyTarget(id) {
		return this.httpRequest('DELETE', `/genie/master-company-targets/${id}`, null);
	}

	// ─── Genie: Review and Approval ───────────────────────────────────────────
	getGenieReviewAndApproval(data) {
		const filters = {
			...(data?.start_date ? {start_date: data.start_date} : {}),
			...(data?.end_date ? {end_date: data.end_date} : {}),
			...(data?.approval_status ? {approval_status: data.approval_status} : {}),
			...(data?.event_status ? {event_status: data.event_status} : {}),
		};

		const payload = {
			page: data?.page ?? data?.current ?? 1,
			limit: data?.limit ?? data?.pageSize ?? 10,
			search_term: data?.search_term ?? data?.searchTerm ?? '',
			filters,
		};

		return this.httpRequest('POST', `/genie/review-and-approval`, payload);
	}
	downloadGenieReviewAndApproval(data = {}) {
		const filters = {
			...(data?.start_date ? {start_date: data.start_date} : {}),
			...(data?.end_date ? {end_date: data.end_date} : {}),
			...(data?.approval_status ? {approval_status: data.approval_status} : {}),
			...(data?.event_status ? {event_status: data.event_status} : {}),
		};

		const payload = {
			search_term: data?.search_term ?? data?.searchTerm ?? '',
			filters,
		};

		return this.httpRequest('POST', `/genie/review-and-approval/download`, payload);
	}
	updateGenieReviewAndApproval(data) {
		return this.httpRequest('POST', `/genie/review-and-approval/approval`, data);
	}
	getGenieReviewAndApprovalById(id) {
		return this.httpRequest('GET', `/genie/review-and-approval/${id}`, null);
	}

	// ─── Genie: Master Activity Targets ──────────────────────────────────────
	getGenieActivityTargets(filters = {}) {
		const params = new URLSearchParams(filters).toString();
		return this.httpRequest('GET', `/genie/master-activity-targets?${params}`, null);
	}
	createGenieActivityTarget(data) {
		return this.httpRequest('POST', `/genie/master-activity-targets`, data);
	}
	bulkUpdateMasterActivityTargets(data) {
		return this.httpRequest('PUT', `/genie/master-activity-targets`, data);
	}
	bulkDeleteMasterActivityTargets(data) {
		return this.httpRequest('DELETE', `/genie/master-activity-targets`, data);
	}

	// ─── Genie: Master Skill Development Targets ─────────────────────────────
	getMasterSkillDevelopmentTargets(data) {
		return this.httpRequest('POST', `/genie/master-skill-development-targets/list`, data);
	}
	createMasterSkillDevelopmentTarget(data) {
		return this.httpRequest('POST', `/genie/master-skill-development-targets`, data);
	}
	bulkUpdateMasterSkillDevelopmentTargets(data) {
		return this.httpRequest('PUT', `/genie/master-skill-development-targets`, data);
	}
	bulkDeleteMasterSkillDevelopmentTargets(data) {
		return this.httpRequest('DELETE', `/genie/master-skill-development-targets`, data);
	}

	// ─── Genie: Master GMV ───────────────────────────────────────────────────
	getGenieGmv() {
		return this.httpRequest('GET', `/genie/master-gmv`, null);
	}
	getGenieGmvById(id) {
		return this.httpRequest('GET', `/genie/master-gmv/${id}`, null);
	}
	createGenieGmv(data) {
		return this.httpRequest('POST', `/genie/master-gmv`, data);
	}
	updateGenieGmv(data, id) {
		return this.httpRequest('PUT', `/genie/master-gmv/${id}`, data);
	}
	deleteGenieGmv(id) {
		return this.httpRequest('DELETE', `/genie/master-gmv/${id}`, null);
	}

	// ─── Genie: Master Pillar Mapping ────────────────────────────────
	getMasterPillarPinMappings() {
		return this.httpRequest('GET', `/genie/master-pillar-pin-mappings`, null);
	}
	getMasterPillarDescriptions() {
		return this.httpRequest('GET', `/genie/master-pillar-pin-mappings/descriptions`, null);
	}
	createMasterPillarPinMapping(data) {
		return this.httpRequest('POST', `/genie/master-pillar-pin-mappings`, data);
	}
	updateMasterPillarPinMapping(id, data) {
		return this.httpRequest('PUT', `/genie/master-pillar-pin-mappings/${id}`, data);
	}

	// ─── Genie: Master Activity ──────────────────────────────────────
	getGenieActivities() {
		return this.httpRequest('GET', `/genie/master-activity`, null);
	}
	createGenieActivity(data) {
		return this.httpRequest('POST', `/genie/master-activity`, data);
	}
	getGenieActivityBySlug(slug) {
		return this.httpRequest('GET', `/genie/master-activity/${slug}`, null);
	}
	updateGenieActivity(data, slug) {
		return this.httpRequest('PUT', `/genie/master-activity/${slug}`, data);
	}
	deleteGenieActivity(slug) {
		return this.httpRequest('DELETE', `/genie/master-activity/${slug}`, null);
	}

	// ─── Genie: Target Report ─────────────────────────────────────────────
	getGenieTargetReport(params = {}) {
		const query = new URLSearchParams(params).toString();
		return this.httpRequest('GET', `/genie/target-report${query ? `?${query}` : ''}`, null);
	}

	// ─── Genie: Achievement Report ────────────────────────────────────────
	getGenieAchievementReport(params = {}) {
		const query = new URLSearchParams(params).toString();
		return this.httpRequest('GET', `/genie/achievement-report${query ? `?${query}` : ''}`, null);
	}

	//get ranks
	getRanks() {
		return this.httpRequest('GET', `/generic/ranks`, null);
	}

	// Consistency Data
	getConsistencyData(params) {
		return this.httpRequest('POST', '/business/consistency/all', params);
	}

	// Consistency Data Export
	exportConsistencyData(params) {
		return this.httpRequestBlob('POST', '/business/consistency/export', params);
	}

	// Consistency Data Generation
	generateConsistencyData(params) {
		return this.httpRequest('POST', '/business/consistency/generate', params);
	}

	// associate buyer : get bill/return items details
	getAbRepurchaseBillItemsData(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/repurchase/bill-items`, data);
	}

	getAbDetailsRepurchaseBillItemsData(data) {
		return this.httpRequest('POST', `/kyc-admin/associate-buyer/ab-details/repurchase/bill-items`, data);
	}

	// registered buyer : get bill/return items details
	getRBRepurchaseBillItemsData(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/registered-buyer/repurchase/bill-items`, data);
	}

	// registered buyer : repurchase summary
	getRBRepurchaseSummaryDetail(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/registered-buyer/repurchase/summary`, data);
	}

	// registered buyer : repurchase details
	getRBRepurhaseRowDetailData(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/registered-buyer/repurchase/details`, data);
	}

	// normal buyer : get bill/return items details
	getNBRepurchaseBillItemsData(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/normal-buyer/repurchase/bill-items`, data);
	}

	// normal buyer : repurchase summary
	getNBRepurchaseSummaryDetail(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/normal-buyer/repurchase/summary`, data);
	}

	// normal buyer : repurchase details
	getNBRepurhaseRowDetailData(data) {
		return this.httpRequest('POST', `/kyc-admin/miscellaneous/normal-buyer/repurchase/details`, data);
	}

	getMasterPinDescList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-pin-desc/list`);
	}
	getMasterDocumentsList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-documents/list`);
	}
	getMasterOccupationsList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-occupations/list`);
	}
	getMasterRelationsList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-relations/list`);
	}
	getMasterDiamondClubList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-diamond-club/list`);
	}
	getMasterCompanyList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-company-list/list`);
	}
	getMasterKycReasonDescList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-kyc-reason-desc/list`);
	}
	getMasterDepartmentList() {
		return this.httpRequest('POST', `/kyc-admin/masters/master-department-list/list`);
	}

	// API Call to fetch all Sehat Mitra Course Registered Users
	getSehatMitraCourseUsers(page = 1, pageSize = 10, searchTerm = '', filterTerm) {
		let url = `/sehat-mitra/course-registrations/all/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to download Sehat Mitra Course Registered Users
	downloadSehatMitraCourseUsers(searchTerm = '', filterTerm) {
		let url = `/sehat-mitra/course-registrations/download-registered-users?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to fetch all Sehat Mitra Course Summary
	getSehatMitraCourseSummary(page = 1, pageSize = 10, searchTerm = '', filterTerm) {
		let url = `/sehat-mitra/course-registrations/all-summary/${page}/${pageSize}?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Call to download Sehat Mitra Course Summary
	downloadSehatMitraCourseSummary(searchTerm = '', filterTerm) {
		let url = `/sehat-mitra/course-registrations/download-summary?`;
		if (searchTerm) {
			url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
		}
		if (filterTerm) {
			url += `&filterTerm=${filterTerm}`;
		}
		return this.httpRequest('GET', url);
	}

	// API Calls for Report Execution Analytics
	getReportAnalyticsSummary(days = 30) {
		return this.httpRequest('GET', `/report-analytics/summary?days=${days}`);
	}

	getReportExecutionsList(reportName, limit = 50, dbSource = null) {
		let url = `/report-analytics/${encodeURIComponent(reportName)}/executions?limit=${limit}`;
		if (dbSource) {
			url += `&dbSource=${encodeURIComponent(dbSource)}`;
		}
		return this.httpRequest('GET', url);
	}

	// Cash Bonus Data
	getCashBonusData(params) {
		return this.httpRequest('POST', '/business/cash-bonus/cash-bonus-data', params);
	}

	generateCashBonusData(params) {
		return this.httpRequest('POST', '/business/cash-bonus/start-cash-bonus-generation', params);
	}

	// Cash Bonus Data Force Generation (SuperAdmin)
	forceGenerateCashBonusData(params) {
		return this.httpRequest('POST', '/business/cash-bonus/force-start-cash-bonus-generation', params);
	}

	// Consistency Data Force Generation (SuperAdmin)
	forceGenerateConsistencyData(params) {
		return this.httpRequest('POST', '/business/consistency/force-generate', params);
	}

	// Final Cash Bonus
	getFinalCashBonusList(params) {
		return this.httpRequest('POST', `/business/final-cash-bonus/list`, params);
	}

	importFinalCashBonus(formData) {
		return this.httpRequest('POST', '/business/final-cash-bonus/bulk-upload', formData, {
			multiPart: true,
		});
	}

	// Final RCM Consistency
	getFinalRcmConsistencyList(params) {
		return this.httpRequest('POST', `/business/final-rcm-consistency/list`, params);
	}

	importFinalRcmConsistency(formData) {
		return this.httpRequest('POST', '/business/final-rcm-consistency/bulk-upload', formData, {
			multiPart: true,
		});
	}

	// ─── Drive Management: Revenue Targets ───────────────────────────────────
	getDriveRevenueTargets(financial_year) {
		const qs = financial_year ? `?financial_year=${encodeURIComponent(financial_year)}` : '';
		return this.httpRequest('GET', `/drive-management/revenue-targets${qs}`, null);
	}
	getDriveRevenueTargetById(id) {
		return this.httpRequest('GET', `/drive-management/revenue-targets/${id}`, null);
	}
	createDriveRevenueTarget(data) {
		return this.httpRequest('POST', `/drive-management/revenue-targets`, data);
	}
	updateDriveRevenueTarget(data, id) {
		return this.httpRequest('PUT', `/drive-management/revenue-targets/${id}`, data);
	}

	// ─── Drive Management: Revenue Report ────────────────────────────────────
	getDriveRevenueReport(financial_year) {
		return this.httpRequest(
			'GET',
			`/drive-management/revenue-report?financial_year=${encodeURIComponent(financial_year)}`,
			null
		);
	}

	// ─── Drive Management: Reactivation Report ───────────────────────────────
	getDriveReactivationReport(financialYear) {
		const qs = financialYear ? `?financial_year=${encodeURIComponent(financialYear)}` : '';
		return this.httpRequest('GET', `/drive-management/reactivation-report${qs}`);
	}

	// ─── Drive Management: MIS Report (New KYC CY vs LY) ─────────────────────
	getDriveMisReport(financialYear) {
		const qs = financialYear ? `?financial_year=${encodeURIComponent(financialYear)}` : '';
		return this.httpRequest('GET', `/drive-management/mis-report${qs}`);
	}

	// Home Page Cache Manager
	async clearHomePageCache(data) {
		return this.httpRequest('POST', '/home-page-cache/clear', data);
	}
	// Gooddot Rasoi Batches
	getGooddotRasoiBatches(params) {
		const queryStr = params ? new URLSearchParams(params).toString() : '';
		return this.httpRequest('GET', `/gooddot-rasoi/admin/batches?${queryStr}`);
	}

	getGooddotRasoiBatchDetails(id) {
		return this.httpRequest('GET', `/gooddot-rasoi/admin/batch/${id}`);
	}

	createGooddotRasoiBatch(formData) {
		return this.httpRequest('POST', '/gooddot-rasoi/admin/batch', formData, {multiPart: true});
	}

	updateGooddotRasoiBatch(id, formData) {
		return this.httpRequest('PUT', `/gooddot-rasoi/admin/batch/${id}`, formData, {
			multiPart: true,
		});
	}

	deleteGooddotRasoiBatch(id) {
		return this.httpRequest('DELETE', `/gooddot-rasoi/admin/batch/${id}`);
	}

	getGooddotRasoiApplications(params) {
		const queryStr = params ? new URLSearchParams(params).toString() : '';
		if (params && params.isExport) {
			return this.httpRequestBlob('GET', `/gooddot-rasoi/admin/applications?${queryStr}`);
		}
		return this.httpRequest('GET', `/gooddot-rasoi/admin/applications?${queryStr}`);
	}

	getGooddotRasoiReport(params) {
		const queryStr = params ? new URLSearchParams(params).toString() : '';
		if (params && params.isExport) {
			return this.httpRequestBlob('GET', `/gooddot-rasoi/admin/report?${queryStr}`);
		}
		return this.httpRequest('GET', `/gooddot-rasoi/admin/report?${queryStr}`);
	}

	// ---------- Product Availability Tracking ----------
	/**
	 * GET /product-availability-tracking?page=&pageSize=&searchTerm=
	 */
	getProductAvailabilityTrackings(params) {
		const query = new URLSearchParams(params).toString();
		return this.httpRequest('GET', `/product-availability-tracking?${query}`, null);
	}

	/**
	 * GET /product-availability-tracking/:id
	 */
	getProductAvailabilityTrackingById(id) {
		return this.httpRequest('GET', `/product-availability-tracking/${id}`, null);
	}

	/**
	 * GET /product-availability-tracking/search/:searchText
	 */
	searchProductBySapCode(searchText) {
		return this.httpRequest('GET', `/product-availability-tracking/search/${searchText}`);
	}

	/**
	 * POST /product-availability-tracking   { sap_code }
	 */
	createProductAvailabilityTracking(data) {
		return this.httpRequest('POST', `/product-availability-tracking`, data);
	}

	/**
	 * PUT /product-availability-tracking/:id   { sap_code?, is_trackable? }
	 */
	updateProductAvailabilityTracking(id, data) {
		return this.httpRequest('PUT', `/product-availability-tracking/${id}`, data);
	}

	/**
	 * DELETE /product-availability-tracking/:id
	 */
	deleteProductAvailabilityTracking(id) {
		return this.httpRequest('DELETE', `/product-availability-tracking/${id}`, null);
	}

	/**
	 * POST /product-availability-tracking/link/:id   { link_sap_code }
	 */
	addProductAvailabilityLinkSapCode(id, data) {
		return this.httpRequest('POST', `/product-availability-tracking/link/${id}`, data);
	}

	/**
	 * DELETE /product-availability-tracking/link/:id   { link_sap_code }
	 */
	removeProductAvailabilityLinkSapCode(id, data) {
		return this.httpRequest('DELETE', `/product-availability-tracking/link/${id}`, data);
	}

	/**
	 * GET /product-availability-tracking/lookup/:sap_code — fetch-only, does not insert
	 */
	lookupProductBySapCode(sap_code) {
		return this.httpRequest('GET', `/product-availability-tracking/lookup/${encodeURIComponent(sap_code)}`, null);
	}
	generateManualRefund(order_no, params) {
		return this.httpRequest('POST', `/crm_order/${order_no}/refund`, params);
	}

	getRefundTracking(order_no) {
		return this.httpRequest('GET', `/crm_order/${order_no}/refunds`);
	}

	getRefundableAmount(order_no) {
		return this.httpRequest('GET', `/crm_order/${order_no}/refundable-amount`);
	}

	// ─── Drive Management: Repurchaser Zone Targets ─────────────────────────────
	getRepurchaserZoneTargets(financial_year) {
		const qs = financial_year ? `?financial_year=${encodeURIComponent(financial_year)}` : '';

		return this.httpRequest('GET', `/drive-management/repurchaser-target${qs}`, null);
	}

	getRepurchaserZoneTargetById(id) {
		return this.httpRequest('GET', `/drive-management/repurchaser-target/${id}`, null);
	}

	createRepurchaserZoneTarget(data) {
		return this.httpRequest('POST', `/drive-management/repurchaser-target`, data);
	}

	updateRepurchaserZoneTarget(id, data) {
		return this.httpRequest('PUT', `/drive-management/repurchaser-target/${id}`, data);
	}

	// ─── Drive Management: Repurchaser Zone Report ─────────────────────────────
	getRepurchaserZoneReport(financialYear) {
		const qs = financialYear ? `?financial_year=${encodeURIComponent(financialYear)}` : '';
		return this.httpRequest('GET', `/drive-management/repurchaser-report${qs}`);
	}

	// KYC Admin Accounts Payment Entry
	uploadPaymentEntryData(data) {
		return this.httpRequest('POST', '/kyc-admin/accounts/payment-entry/upload', data);
	}
	// KYC Admin Accounts Business Entry
	uploadBusinessEntryData(data) {
		return this.httpRequest('POST', '/kyc-admin/accounts/business-entry/upload', data);
	}
	// KYC Admin Accounts JV Voucher Entry
	uploadJvVoucherData(data) {
		return this.httpRequest('POST', '/kyc-admin/accounts/jv-voucher/upload', data);
	}

	// Associate Buyer => Enable Bulk Bank Enabled with Bank No validation
	enabledBulkUploadedBankListWithBankNo(data) {
		return this.httpRequest('POST', `/kyc-admin/delete-info/bank-account/enabled-bulk-list-with-bank-no`, data);
	}

	// south ceremony event leaders APIs
	getSouthCeremonyEventLeaders({page, pageSize, legType}) {
		let url = `/south-ceremony-event/leaders?page=${page}&pageSize=${pageSize}`;

		if (legType) {
			url += `&leg_type=${legType}`;
		}

		return this.httpRequest('GET', url, null);
	}

	searchSouthCeremonyEventLeader(abId) {
		return this.httpRequest('GET', `/south-ceremony-event/leaders/search/${abId}`, null);
	}

	createSouthCeremonyEventLeader(payload) {
		return this.httpRequest('POST', '/south-ceremony-event/leaders', payload);
	}

	updateSouthCeremonyEventLeader(id, payload) {
		return this.httpRequest('PUT', `/south-ceremony-event/leaders/${id}`, payload);
	}

	// south ceremony event report assignments APIs
	getSouthCeremonyEventReportAssignments(page, pageSize) {
		return this.httpRequest(
			'GET',
			`/south-ceremony-event/report-assignments?page=${page}&pageSize=${pageSize}`,
			null
		);
	}

	getSouthCeremonyEventReportAssignmentById(id) {
		return this.httpRequest('GET', `/south-ceremony-event/report-assignments/${id}`, null);
	}

	createSouthCeremonyEventReportAssignment(payload) {
		return this.httpRequest('POST', '/south-ceremony-event/report-assignments', payload);
	}

	updateSouthCeremonyEventReportAssignment(id, payload) {
		return this.httpRequest('PUT', `/south-ceremony-event/report-assignments/${id}`, payload);
	}

	getUnethicalJoiningStopDetails(data) {
		return this.httpRequest('POST', '/kyc-admin/reports/unethical-joining-stop/get-details', data);
	}

	bulkUploadUpdateProducts(data, randomId, multiPart = false) {
		return this.httpRequest('POST', `/update-products/bulk-upload/${randomId}`, data, {multiPart});
  }
	/**
	 * Fetch brand or category master list for banner dropdown
	 * @param {*} payload { type: 'brand' | 'category' }
	 */
	
	getBrandCategoryList(payload) {
		return this.httpRequest('POST', `/banner_list/get-list`, payload);
	}

	/**
	 * Fetch product dropdown list for banner redirection with search
	 * @param {*} payload { search?: string, limit?: number }
	 */
	getBannerProductsList(payload) {
		return this.httpRequest('POST', `/banner_list/product-list`, payload);
	}
}
